/**
 * 경기도보 서임급사령 목록 데이터
 */
export const DoboData = [
    {
        "book_id": 65,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1614號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 8,
        "publish_day": 23,
        "publish_date": "昭和14年8月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 66,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第257號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 6,
        "publish_day": 25,
        "publish_date": "昭和4年6月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 67,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第993號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1926,
        "publish_month": 7,
        "publish_day": 2,
        "publish_date": "大正15年7月2日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 68,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第44號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1912,
        "publish_month": 3,
        "publish_day": 8,
        "publish_date": "明治45年3月8日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 69,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第241號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 3,
        "publish_day": 9,
        "publish_date": "大正6年3月9日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 70,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第354號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 5,
        "publish_day": 9,
        "publish_date": "大正8年5月9日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 71,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1643號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 10,
        "publish_day": 30,
        "publish_date": "昭和14年10月30日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 72,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第694號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 8,
        "publish_day": 10,
        "publish_date": "大正12年8月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 73,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1005號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1926,
        "publish_month": 8,
        "publish_day": 13,
        "publish_date": "大正15年8月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 74,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第3號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1912,
        "publish_month": 8,
        "publish_day": 16,
        "publish_date": "大正元年8月16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 75,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第20號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1911,
        "publish_month": 9,
        "publish_day": 22,
        "publish_date": "明治44年9月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 76,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1593號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 7,
        "publish_day": 5,
        "publish_date": "昭和14年7月5日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 77,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1013號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1926,
        "publish_month": 9,
        "publish_day": 10,
        "publish_date": "大正15年9月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 78,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第682號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 6,
        "publish_day": 29,
        "publish_date": "大正12年6月29日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 79,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第728號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 12,
        "publish_day": 7,
        "publish_date": "大正12年12月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 80,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1602號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 7,
        "publish_day": 26,
        "publish_date": "昭和14年7月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 81,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第342號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 2,
        "publish_day": 14,
        "publish_date": "大正8年2月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 82,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第508號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 10,
        "publish_day": 11,
        "publish_date": "大正10年10月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 83,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第339號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 1,
        "publish_day": 24,
        "publish_date": "大正8年1月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 84,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第704號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 9,
        "publish_day": 14,
        "publish_date": "大正12年9月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 85,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第46號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 6,
        "publish_day": 13,
        "publish_date": "大正2年6月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 86,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第524號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 12,
        "publish_day": 6,
        "publish_date": "大正10年12月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 87,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第183號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 1,
        "publish_day": 28,
        "publish_date": "大正5年1月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 88,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第381號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 11,
        "publish_day": 14,
        "publish_date": "大正8年11月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 89,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1638號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 10,
        "publish_day": 18,
        "publish_date": "昭和14年10月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 90,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第378號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 10,
        "publish_day": 24,
        "publish_date": "大正8年10月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 91,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第50號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 7,
        "publish_day": 11,
        "publish_date": "大正2年7月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 92,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第498號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 9,
        "publish_day": 6,
        "publish_date": "大正10年9月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 93,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第477號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 6,
        "publish_day": 24,
        "publish_date": "大正10年6月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 94,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第195號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 4,
        "publish_day": 21,
        "publish_date": "大正5年4月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 95,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第712號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 10,
        "publish_day": 12,
        "publish_date": "大正12年10月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 96,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第358號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 6,
        "publish_day": 6,
        "publish_date": "大正8年6月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 97,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第512號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 10,
        "publish_day": 25,
        "publish_date": "大正10年10月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 98,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1618號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 9,
        "publish_day": 1,
        "publish_date": "昭和14年9月1日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 99,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第48號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1912,
        "publish_month": 4,
        "publish_day": 5,
        "publish_date": "明治45年4月5日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 100,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第50號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 6,
        "publish_day": 21,
        "publish_date": "昭和2年6月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 101,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1009號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1926,
        "publish_month": 8,
        "publish_day": 27,
        "publish_date": "大正15年8月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 102,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第27號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 1,
        "publish_day": 31,
        "publish_date": "大正2年1月31日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 103,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第677號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 6,
        "publish_day": 12,
        "publish_date": "大正12年6月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 104,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第19號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1912,
        "publish_month": 12,
        "publish_day": 6,
        "publish_date": "大正元年12月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 105,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第724號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 11,
        "publish_day": 24,
        "publish_date": "大正12年11月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 106,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第46號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 6,
        "publish_day": 7,
        "publish_date": "昭和2年6月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 107,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第31號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 2,
        "publish_day": 28,
        "publish_date": "大正2年2月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 108,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第504號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 9,
        "publish_day": 27,
        "publish_date": "大正10年9月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 109,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第708號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 9,
        "publish_day": 28,
        "publish_date": "大正12年9月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 110,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第86號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 3,
        "publish_day": 20,
        "publish_date": "大正3年3月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 111,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第362號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 7,
        "publish_day": 4,
        "publish_date": "大正8年7月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 112,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第528號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 12,
        "publish_day": 20,
        "publish_date": "大正10年12月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 113,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第482號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 7,
        "publish_day": 12,
        "publish_date": "大正10年7月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 114,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1622號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 9,
        "publish_day": 11,
        "publish_date": "昭和14年9月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 115,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第494號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 8,
        "publish_day": 23,
        "publish_date": "大正10年8月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 116,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第374號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 9,
        "publish_day": 26,
        "publish_date": "大正8年9月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 117,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1598號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 7,
        "publish_day": 17,
        "publish_date": "昭和14年7月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 118,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第236號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 2,
        "publish_day": 2,
        "publish_date": "大正6年2月2日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 119,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第16號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1911,
        "publish_month": 8,
        "publish_day": 25,
        "publish_date": "明治44年8月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 120,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第90號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 4,
        "publish_day": 17,
        "publish_date": "大正3年4月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 121,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第91號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 4,
        "publish_day": 24,
        "publish_date": "大正3年4月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 122,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1635號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 10,
        "publish_day": 11,
        "publish_date": "昭和14年10月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 123,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第495號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 8,
        "publish_day": 26,
        "publish_date": "大正10年8月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 124,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第375號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 10,
        "publish_day": 3,
        "publish_date": "大正8年10月3日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 125,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第529號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 12,
        "publish_day": 23,
        "publish_date": "大正10年12月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 126,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第483號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 7,
        "publish_day": 15,
        "publish_date": "大正10年7月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 127,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1911,
        "publish_month": 5,
        "publish_day": 12,
        "publish_date": "明治44年5月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 128,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第22號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1912,
        "publish_month": 12,
        "publish_day": 27,
        "publish_date": "大正元年12月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 129,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第87號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 3,
        "publish_day": 27,
        "publish_date": "大正3年3月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 130,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第709號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 10,
        "publish_day": 2,
        "publish_date": "大正12年10月2日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 131,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第505號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 9,
        "publish_day": 30,
        "publish_date": "大正10年9月30日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 132,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第47號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 6,
        "publish_day": 10,
        "publish_date": "昭和2年6月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 133,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第30號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 2,
        "publish_day": 21,
        "publish_date": "大正2年2月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 134,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第18號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1912,
        "publish_month": 11,
        "publish_day": 29,
        "publish_date": "大正元年11月29日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 135,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1624號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 9,
        "publish_day": 15,
        "publish_date": "昭和14年9月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 136,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第51號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 6,
        "publish_day": 24,
        "publish_date": "昭和2年6月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 137,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第699號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 8,
        "publish_day": 28,
        "publish_date": "大正12年8月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 138,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1008號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1926,
        "publish_month": 8,
        "publish_day": 24,
        "publish_date": "大正15年8月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 139,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第26號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 1,
        "publish_day": 24,
        "publish_date": "大正2年1月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 140,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1619號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 9,
        "publish_day": 4,
        "publish_date": "昭和14年9月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 141,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第359號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 6,
        "publish_day": 13,
        "publish_date": "大正8年6月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 142,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第513號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 10,
        "publish_day": 28,
        "publish_date": "大正10年10月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 143,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第713號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 10,
        "publish_day": 16,
        "publish_date": "大正12年10月16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 144,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第379號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 10,
        "publish_day": 31,
        "publish_date": "大正8年10月31日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 145,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第51號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 7,
        "publish_day": 18,
        "publish_date": "大正2年7月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 146,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第499號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 9,
        "publish_day": 9,
        "publish_date": "大正10年9月9日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 147,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第476號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 6,
        "publish_day": 21,
        "publish_date": "大正10年6月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 148,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第194號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 4,
        "publish_day": 14,
        "publish_date": "大正5年4月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 149,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第47號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 6,
        "publish_day": 20,
        "publish_date": "大正2年6月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 150,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第182號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 1,
        "publish_day": 21,
        "publish_date": "大正5年1月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 151,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第380號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 11,
        "publish_day": 7,
        "publish_date": "大正8年11月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 152,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第338號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 1,
        "publish_day": 17,
        "publish_date": "大正8年1月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 153,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第343號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 2,
        "publish_day": 21,
        "publish_date": "大正8年2月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 154,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第509號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 10,
        "publish_day": 14,
        "publish_date": "大正10年10月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 155,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1603號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 7,
        "publish_day": 28,
        "publish_date": "昭和14年7月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 156,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第53號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1912,
        "publish_month": 5,
        "publish_day": 3,
        "publish_date": "明治45年5月3日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 157,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1592號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 7,
        "publish_day": 3,
        "publish_date": "昭和14年7月3日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 158,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1012號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1926,
        "publish_month": 9,
        "publish_day": 7,
        "publish_date": "大正15年9月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 159,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第683號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 7,
        "publish_day": 3,
        "publish_date": "大正12年7月3日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 160,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1912,
        "publish_month": 8,
        "publish_day": 9,
        "publish_date": "大正元年8月9日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 161,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第21號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1911,
        "publish_month": 9,
        "publish_day": 29,
        "publish_date": "明治44年9月29日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 162,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1004號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1926,
        "publish_month": 8,
        "publish_day": 10,
        "publish_date": "大正15年8月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 163,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1642號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 10,
        "publish_day": 27,
        "publish_date": "昭和14年10月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 164,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第14號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1912,
        "publish_month": 11,
        "publish_day": 1,
        "publish_date": "大正元年11月1日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 165,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第240號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 3,
        "publish_day": 2,
        "publish_date": "大正6年3月2日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 166,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第355號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 5,
        "publish_day": 16,
        "publish_date": "大正8年5月16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 167,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1615號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 8,
        "publish_day": 25,
        "publish_date": "昭和14年8月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 168,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第256號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 6,
        "publish_day": 21,
        "publish_date": "昭和4年6月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 169,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第45號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1912,
        "publish_month": 3,
        "publish_day": 15,
        "publish_date": "明治45年3月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 170,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第514號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 11,
        "publish_day": 1,
        "publish_date": "大正10年11月1日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 171,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第999號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1926,
        "publish_month": 7,
        "publish_day": 23,
        "publish_date": "大正15年7月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 172,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第734號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 12,
        "publish_day": 28,
        "publish_date": "大正12年12月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 173,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1623號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 9,
        "publish_day": 13,
        "publish_date": "昭和14年9月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 174,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第671號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 5,
        "publish_day": 22,
        "publish_date": "大正12年5月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 175,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第40號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 5,
        "publish_day": 17,
        "publish_date": "昭和2年5月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 176,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第722號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 11,
        "publish_day": 16,
        "publish_date": "大正12年11月16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 177,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第667號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 5,
        "publish_day": 8,
        "publish_date": "大正12年5月8日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 178,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第37號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 4,
        "publish_day": 11,
        "publish_date": "大正2年4月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 179,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第9號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1912,
        "publish_month": 9,
        "publish_day": 27,
        "publish_date": "大正元年9月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 180,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第364號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 7,
        "publish_day": 18,
        "publish_date": "大正8年7月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 181,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第348號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 3,
        "publish_day": 28,
        "publish_date": "大正8年3月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 182,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第502號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 9,
        "publish_day": 20,
        "publish_date": "大正10年9月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 183,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1608號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 8,
        "publish_day": 9,
        "publish_date": "昭和14年8月9日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 184,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第6號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1911,
        "publish_month": 6,
        "publish_day": 16,
        "publish_date": "明治44年6月16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 185,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第80號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 2,
        "publish_day": 6,
        "publish_date": "大正3年2月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 186,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第484號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 7,
        "publish_day": 19,
        "publish_date": "大正10年7月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 187,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第189號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 3,
        "publish_day": 10,
        "publish_date": "大正5年3月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 188,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第372號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 9,
        "publish_day": 12,
        "publish_date": "大正8年9月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 189,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第492號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 8,
        "publish_day": 16,
        "publish_date": "大正10年8月16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 190,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第62號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1912,
        "publish_month": 7,
        "publish_day": 12,
        "publish_date": "明治45年7月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 191,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1632號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 10,
        "publish_day": 4,
        "publish_date": "昭和14年10月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 192,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第718號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 11,
        "publish_day": 2,
        "publish_date": "大正12年11月2日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 193,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第79號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 1,
        "publish_day": 30,
        "publish_date": "大正3年1月30日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 194,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第10號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1911,
        "publish_month": 7,
        "publish_day": 14,
        "publish_date": "明治44年7月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 195,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第995號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1926,
        "publish_month": 7,
        "publish_day": 9,
        "publish_date": "大正15年7月9日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 196,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第251號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 6,
        "publish_day": 4,
        "publish_date": "昭和4年6月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 197,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第352號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 4,
        "publish_day": 25,
        "publish_date": "大正8年4月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 198,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第247號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 4,
        "publish_day": 20,
        "publish_date": "大正6年4月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 199,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第518號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 11,
        "publish_day": 15,
        "publish_date": "大正10年11月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 200,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1645號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 11,
        "publish_day": 4,
        "publish_date": "昭和14年11月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 201,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第30號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1911,
        "publish_month": 12,
        "publish_day": 1,
        "publish_date": "明治44年12月1日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 202,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第692號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 8,
        "publish_day": 3,
        "publish_date": "大正12年8月3日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 203,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1003號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1926,
        "publish_month": 8,
        "publish_day": 6,
        "publish_date": "大正15年8月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 204,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第5號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1912,
        "publish_month": 8,
        "publish_day": 30,
        "publish_date": "大正元年8月30日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 205,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第26號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1911,
        "publish_month": 11,
        "publish_day": 3,
        "publish_date": "明治44年11月3日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 206,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1015號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1926,
        "publish_month": 9,
        "publish_day": 17,
        "publish_date": "大正15年9月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 207,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第684號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 7,
        "publish_day": 6,
        "publish_date": "大正12年7月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 208,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1595號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 7,
        "publish_day": 10,
        "publish_date": "昭和14年7月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 209,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1604號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 7,
        "publish_day": 31,
        "publish_date": "昭和14年7月31日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 210,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第247號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 5,
        "publish_day": 21,
        "publish_date": "昭和4年5月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 211,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第344號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 2,
        "publish_day": 28,
        "publish_date": "大正8年2月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 212,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第702號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 9,
        "publish_day": 7,
        "publish_date": "大正12年9月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 213,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1628號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 9,
        "publish_day": 25,
        "publish_date": "昭和14年9月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 214,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第368號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 8,
        "publish_day": 15,
        "publish_date": "大正8年8月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 215,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第40號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 5,
        "publish_day": 2,
        "publish_date": "大正2年5月2日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 216,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第488號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 8,
        "publish_day": 2,
        "publish_date": "大正10年8月2日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 217,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第522號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 11,
        "publish_day": 29,
        "publish_date": "大正10年11月29日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 218,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第467號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 5,
        "publish_day": 20,
        "publish_date": "大正10年5月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 219,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第185號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 2,
        "publish_day": 11,
        "publish_date": "大正5年2月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 220,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第37號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 5,
        "publish_day": 6,
        "publish_date": "昭和2年5月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 221,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第387號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 12,
        "publish_day": 26,
        "publish_date": "大正8年12月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 222,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第56號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 8,
        "publish_day": 22,
        "publish_date": "大正2年8月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 223,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第193號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 4,
        "publish_day": 7,
        "publish_date": "大正5年4月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 224,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第471號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 6,
        "publish_day": 3,
        "publish_date": "大正10年6月3日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 225,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第39號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1912,
        "publish_month": 2,
        "publish_day": 2,
        "publish_date": "明治45年2月2日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 226,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第714號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 10,
        "publish_day": 19,
        "publish_date": "大正12年10月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 227,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第715號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 10,
        "publish_day": 23,
        "publish_date": "大正12年10月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 228,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第38號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1912,
        "publish_month": 1,
        "publish_day": 26,
        "publish_date": "明治45年1月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 229,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第57號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 8,
        "publish_day": 29,
        "publish_date": "大正2年8月29日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 230,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第192號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 3,
        "publish_day": 31,
        "publish_date": "大正5年3月31日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 231,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第470號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 5,
        "publish_day": 31,
        "publish_date": "大正10年5月31日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 232,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第369號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 8,
        "publish_day": 22,
        "publish_date": "大正8年8月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 233,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第41號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 5,
        "publish_day": 9,
        "publish_date": "大正2年5月9日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 234,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第466號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 5,
        "publish_day": 17,
        "publish_date": "大正10年5月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 235,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第184號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 2,
        "publish_day": 4,
        "publish_date": "大正5年2月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 236,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第36號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 5,
        "publish_day": 3,
        "publish_date": "昭和2年5月3日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 237,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第386號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 12,
        "publish_day": 19,
        "publish_date": "大正8年12月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 238,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1629號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 9,
        "publish_day": 27,
        "publish_date": "昭和14年9月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 239,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第703號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 9,
        "publish_day": 11,
        "publish_date": "大正12年9月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 240,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第345號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 3,
        "publish_day": 7,
        "publish_date": "大正8年3月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 241,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1605號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 8,
        "publish_day": 2,
        "publish_date": "昭和14年8月2日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 242,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第246號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 5,
        "publish_day": 17,
        "publish_date": "昭和4年5月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 243,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第55號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1912,
        "publish_month": 5,
        "publish_day": 24,
        "publish_date": "明治45年5月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 244,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1014號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1926,
        "publish_month": 9,
        "publish_day": 14,
        "publish_date": "大正15年9月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 245,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1594號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 7,
        "publish_day": 7,
        "publish_date": "昭和14年7月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 246,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第27號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1911,
        "publish_month": 11,
        "publish_day": 10,
        "publish_date": "明治44年11月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 247,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1644號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 11,
        "publish_day": 1,
        "publish_date": "昭和14年11月1日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 248,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第12號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1912,
        "publish_month": 10,
        "publish_day": 18,
        "publish_date": "大正元年10月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 249,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第31號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1911,
        "publish_month": 12,
        "publish_day": 8,
        "publish_date": "明治44年12月8日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 250,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第353號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 5,
        "publish_day": 2,
        "publish_date": "大正8年5月2日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 251,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第246號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 4,
        "publish_day": 13,
        "publish_date": "大正6年4月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 252,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第519號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 11,
        "publish_day": 18,
        "publish_date": "大正10年11月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 253,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1613號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 8,
        "publish_day": 21,
        "publish_date": "昭和14年8月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 254,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第43號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1912,
        "publish_month": 3,
        "publish_day": 1,
        "publish_date": "明治45年3月1日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 255,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第994號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1926,
        "publish_month": 7,
        "publish_day": 6,
        "publish_date": "大正15年7月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 256,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第250號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 5,
        "publish_day": 31,
        "publish_date": "昭和4年5月31日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 257,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第11號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1911,
        "publish_month": 7,
        "publish_day": 21,
        "publish_date": "明治44年7月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 258,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第63號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1912,
        "publish_month": 7,
        "publish_day": 19,
        "publish_date": "明治45年7月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 259,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1633號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 10,
        "publish_day": 6,
        "publish_date": "昭和14年10月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 260,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第373號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 9,
        "publish_day": 19,
        "publish_date": "大正8年9月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 261,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第493號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 8,
        "publish_day": 19,
        "publish_date": "大正10年8月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 262,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1625號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 9,
        "publish_day": 18,
        "publish_date": "昭和14年9月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 263,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第365號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 7,
        "publish_day": 25,
        "publish_date": "大正8年7月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 264,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第7號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1911,
        "publish_month": 6,
        "publish_day": 23,
        "publish_date": "明治44年6月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 265,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第81號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 2,
        "publish_day": 13,
        "publish_date": "大正3年2月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 266,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1609號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 8,
        "publish_day": 11,
        "publish_date": "昭和14年8月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 267,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第59號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1912,
        "publish_month": 6,
        "publish_day": 21,
        "publish_date": "明治45年6月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 268,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第349號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 4,
        "publish_day": 4,
        "publish_date": "大正8年4月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 269,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第503號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 9,
        "publish_day": 23,
        "publish_date": "大正10年9月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 270,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第8號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1912,
        "publish_month": 9,
        "publish_day": 20,
        "publish_date": "大正元年9月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 271,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第41號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 5,
        "publish_day": 20,
        "publish_date": "昭和2年5月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 272,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第723號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 11,
        "publish_day": 20,
        "publish_date": "大正12年11月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 273,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1018號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1926,
        "publish_month": 9,
        "publish_day": 28,
        "publish_date": "大正15年9月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 274,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第689號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 7,
        "publish_day": 24,
        "publish_date": "大正12年7月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 275,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第666號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 5,
        "publish_day": 4,
        "publish_date": "大正12年5月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 276,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第36號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 4,
        "publish_day": 4,
        "publish_date": "大正2年4月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 277,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第670號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 5,
        "publish_day": 18,
        "publish_date": "大正12年5月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 278,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第998號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1926,
        "publish_month": 7,
        "publish_day": 20,
        "publish_date": "大正15年7月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 279,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第515號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 11,
        "publish_day": 4,
        "publish_date": "大正10年11月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 280,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第37號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1912,
        "publish_month": 1,
        "publish_day": 19,
        "publish_date": "明治45年1月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 281,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第12號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1911,
        "publish_month": 7,
        "publish_day": 28,
        "publish_date": "明治44年7月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 282,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1630號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 9,
        "publish_day": 29,
        "publish_date": "昭和14年9月29日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 283,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第60號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1912,
        "publish_month": 6,
        "publish_day": 28,
        "publish_date": "明治45年6月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 284,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第49號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 6,
        "publish_day": 27,
        "publish_date": "大正2年6月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 285,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第490號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 8,
        "publish_day": 9,
        "publish_date": "大正10年8月9日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 286,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第58號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 9,
        "publish_day": 5,
        "publish_date": "大正2年9月5日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 287,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第370號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 8,
        "publish_day": 29,
        "publish_date": "大正8年8月29日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 288,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1626號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 9,
        "publish_day": 20,
        "publish_date": "昭和14年9月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 289,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第469號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 5,
        "publish_day": 27,
        "publish_date": "大正10年5月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 290,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第39號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 5,
        "publish_day": 13,
        "publish_date": "昭和2年5月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 291,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第366號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 8,
        "publish_day": 1,
        "publish_date": "大正8年8月1日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 292,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第486號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 7,
        "publish_day": 26,
        "publish_date": "大正10年7月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 293,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第82號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 2,
        "publish_day": 20,
        "publish_date": "大正3年2月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 294,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第4號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1911,
        "publish_month": 6,
        "publish_day": 2,
        "publish_date": "明治44年6月2日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 295,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第249號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 5,
        "publish_day": 28,
        "publish_date": "昭和4年5月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 296,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第500號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 9,
        "publish_day": 12,
        "publish_date": "大正10年9月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 297,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第28號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1911,
        "publish_month": 11,
        "publish_day": 17,
        "publish_date": "明治44年11月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 298,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第665號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 5,
        "publish_day": 1,
        "publish_date": "大正12年5月1日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 299,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第42號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 5,
        "publish_day": 24,
        "publish_date": "昭和2年5月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 300,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第23號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 1,
        "publish_day": 3,
        "publish_date": "大正2年1月3日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 301,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第673號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 5,
        "publish_day": 29,
        "publish_date": "大正12年5月29日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 302,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1621號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 9,
        "publish_day": 8,
        "publish_date": "昭和14年9月8日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 303,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第516號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 11,
        "publish_day": 8,
        "publish_date": "大正10年11月8日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 304,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第716號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 10,
        "publish_day": 26,
        "publish_date": "大正12年10月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 305,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第77號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 1,
        "publish_day": 16,
        "publish_date": "大正3年1月16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 306,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第473號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 6,
        "publish_day": 10,
        "publish_date": "大正10年6月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 307,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第191號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 3,
        "publish_day": 24,
        "publish_date": "大正5年3月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 308,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第187號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 2,
        "publish_day": 25,
        "publish_date": "大正5年2月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 309,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第385號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 12,
        "publish_day": 12,
        "publish_date": "大正8年12月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 310,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第465號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 5,
        "publish_day": 13,
        "publish_date": "大正10年5月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 311,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第42號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 5,
        "publish_day": 9,
        "publish_date": "大正2年5月9日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 312,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第520號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 11,
        "publish_day": 22,
        "publish_date": "大正10年11月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 313,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第700號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 9,
        "publish_day": 1,
        "publish_date": "大正12年9月1日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 314,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第8號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1911,
        "publish_month": 6,
        "publish_day": 30,
        "publish_date": "明治44年6月30日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 315,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第346號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 3,
        "publish_day": 14,
        "publish_date": "大正8年3月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 316,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第56號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1912,
        "publish_month": 5,
        "publish_day": 31,
        "publish_date": "明治45年5月31日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 317,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第245號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 5,
        "publish_day": 14,
        "publish_date": "昭和4年5月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 318,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1606號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 8,
        "publish_day": 4,
        "publish_date": "昭和14年8月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 319,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第29號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1911,
        "publish_month": 11,
        "publish_day": 24,
        "publish_date": "明治44年11月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 320,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第39號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 4,
        "publish_day": 25,
        "publish_date": "大正2年4月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 321,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第669號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 5,
        "publish_day": 15,
        "publish_date": "大正12年5月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 322,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第686號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 7,
        "publish_day": 13,
        "publish_date": "大正12年7月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 323,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1017號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1926,
        "publish_month": 9,
        "publish_day": 25,
        "publish_date": "大正15年9月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 324,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第24號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1911,
        "publish_month": 10,
        "publish_day": 20,
        "publish_date": "明治44年10月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 325,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第7號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1912,
        "publish_month": 9,
        "publish_day": 13,
        "publish_date": "大正元年9月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 326,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1001號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1926,
        "publish_month": 7,
        "publish_day": 31,
        "publish_date": "大正15年7月31日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 327,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第690號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 7,
        "publish_day": 27,
        "publish_date": "大正12年7月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 328,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第32號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1911,
        "publish_month": 12,
        "publish_day": 15,
        "publish_date": "明治44年12月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 329,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1647號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 11,
        "publish_day": 8,
        "publish_date": "昭和14年11月8日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 330,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第11號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1912,
        "publish_month": 10,
        "publish_day": 11,
        "publish_date": "大正元年10月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 331,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第245號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 4,
        "publish_day": 6,
        "publish_date": "大正6年4月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 332,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第350號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 4,
        "publish_day": 11,
        "publish_date": "大正8年4月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 333,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第253號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 6,
        "publish_day": 11,
        "publish_date": "昭和4年6月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 334,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第40號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1912,
        "publish_month": 2,
        "publish_day": 9,
        "publish_date": "明治45年2月9日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 335,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第997號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1926,
        "publish_month": 7,
        "publish_day": 16,
        "publish_date": "大正15年7月16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 336,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1610號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 8,
        "publish_day": 14,
        "publish_date": "昭和14年8月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 337,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第252號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 6,
        "publish_day": 7,
        "publish_date": "昭和4年6月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 338,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第244號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 3,
        "publish_day": 30,
        "publish_date": "大正6年3月30日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 339,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第351號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 4,
        "publish_day": 18,
        "publish_date": "大正8年4月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 340,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第33號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1911,
        "publish_month": 12,
        "publish_day": 22,
        "publish_date": "明治44年12月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 341,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1000號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1926,
        "publish_month": 7,
        "publish_day": 27,
        "publish_date": "大正15年7月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 342,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第25號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1911,
        "publish_month": 10,
        "publish_day": 27,
        "publish_date": "明治44年10月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 343,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第6號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1912,
        "publish_month": 9,
        "publish_day": 6,
        "publish_date": "大正元年9月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 344,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第38號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 4,
        "publish_day": 18,
        "publish_date": "大正2年4月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 345,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1596號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 7,
        "publish_day": 12,
        "publish_date": "昭和14年7月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 346,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第687號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 7,
        "publish_day": 17,
        "publish_date": "大正12年7月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 347,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1016號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1926,
        "publish_month": 9,
        "publish_day": 21,
        "publish_date": "大正15年9月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 348,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第57號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1912,
        "publish_month": 6,
        "publish_day": 7,
        "publish_date": "明治45年6月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 349,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第244號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 5,
        "publish_day": 10,
        "publish_date": "昭和4年5月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 350,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1607號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 8,
        "publish_day": 7,
        "publish_date": "昭和14年8月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 351,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第347號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 3,
        "publish_day": 21,
        "publish_date": "大正8年3月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 352,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第9號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1911,
        "publish_month": 7,
        "publish_day": 7,
        "publish_date": "明治44年7月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 353,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第701號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 9,
        "publish_day": 4,
        "publish_date": "大正12年9月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 354,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第186號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 2,
        "publish_day": 18,
        "publish_date": "大正5年2月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 355,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第384號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 12,
        "publish_day": 5,
        "publish_date": "大正8年12月5日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 356,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第43號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 5,
        "publish_day": 23,
        "publish_date": "大正2年5月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 357,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第521號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 11,
        "publish_day": 25,
        "publish_date": "大正10年11月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 358,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第472號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 6,
        "publish_day": 7,
        "publish_date": "大正10年6月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 359,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第190號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 3,
        "publish_day": 17,
        "publish_date": "大正5年3月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 360,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第55號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 8,
        "publish_day": 15,
        "publish_date": "大正2年8月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 361,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第54號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1912,
        "publish_month": 5,
        "publish_day": 17,
        "publish_date": "明治45年5月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 362,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第76號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 1,
        "publish_day": 9,
        "publish_date": "大正3年1月9日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 363,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第717號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 10,
        "publish_day": 30,
        "publish_date": "大正12年10月30日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 364,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第517號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 11,
        "publish_day": 11,
        "publish_date": "大正10年11月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 365,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第248號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 4,
        "publish_day": 27,
        "publish_date": "大正6年4月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 366,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第672號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 5,
        "publish_day": 25,
        "publish_date": "大正12年5月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 367,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第43號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 5,
        "publish_day": 27,
        "publish_date": "昭和2年5月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 368,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第501號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 9,
        "publish_day": 16,
        "publish_date": "大正10年9月16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 369,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第248號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 5,
        "publish_day": 24,
        "publish_date": "昭和4年5月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 370,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第5號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1911,
        "publish_month": 6,
        "publish_day": 9,
        "publish_date": "明治44年6月9日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 371,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第468號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 5,
        "publish_day": 24,
        "publish_date": "大正10年5月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 372,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第38號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 5,
        "publish_day": 10,
        "publish_date": "昭和2年5月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 373,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第367號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 8,
        "publish_day": 8,
        "publish_date": "大正8年8月8日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 374,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第487號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 7,
        "publish_day": 29,
        "publish_date": "大正10年7月29日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 375,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1627號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 9,
        "publish_day": 22,
        "publish_date": "昭和14年9月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 376,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第491號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 8,
        "publish_day": 12,
        "publish_date": "大正10年8月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 377,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第59號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 9,
        "publish_day": 12,
        "publish_date": "大正2年9月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 378,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第371號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 9,
        "publish_day": 5,
        "publish_date": "大正8年9月5日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 379,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1631號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 10,
        "publish_day": 2,
        "publish_date": "昭和14年10月2日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 380,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第233號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 1,
        "publish_day": 12,
        "publish_date": "大正6年1月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 381,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第13號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1911,
        "publish_month": 8,
        "publish_day": 4,
        "publish_date": "明治44年8月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 382,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第710號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 10,
        "publish_day": 5,
        "publish_date": "大正12年10月5日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 383,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第18號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1911,
        "publish_month": 9,
        "publish_day": 8,
        "publish_date": "明治44年9月8日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 384,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第475號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 6,
        "publish_day": 17,
        "publish_date": "大正10年6月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 385,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第530號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 12,
        "publish_day": 27,
        "publish_date": "大正10年12月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 386,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第52號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 7,
        "publish_day": 25,
        "publish_date": "大正2年7月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 387,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第463號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 5,
        "publish_day": 6,
        "publish_date": "大正10年5月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 388,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第181號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 1,
        "publish_day": 14,
        "publish_date": "大正5年1月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 389,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第383號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 11,
        "publish_day": 28,
        "publish_date": "大正8年11月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 390,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第44號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 5,
        "publish_day": 23,
        "publish_date": "大正2年5月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 391,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第526號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 12,
        "publish_day": 13,
        "publish_date": "大正10年12月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 392,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1611號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 8,
        "publish_day": 16,
        "publish_date": "昭和14年8月16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 393,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第706號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 9,
        "publish_day": 21,
        "publish_date": "大正12年9月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 394,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第340號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 1,
        "publish_day": 31,
        "publish_date": "大正8年1月31日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 395,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第243號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 5,
        "publish_day": 7,
        "publish_date": "昭和4年5月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 396,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第50號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1912,
        "publish_month": 4,
        "publish_day": 19,
        "publish_date": "明治45年4月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 397,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1600號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 7,
        "publish_day": 21,
        "publish_date": "昭和14年7月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 398,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第680號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 6,
        "publish_day": 22,
        "publish_date": "大正12年6月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 399,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1011號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1926,
        "publish_month": 9,
        "publish_day": 3,
        "publish_date": "大正15年9月3日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 400,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第48號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 6,
        "publish_day": 14,
        "publish_date": "昭和2年6月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 401,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第22號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1911,
        "publish_month": 10,
        "publish_day": 6,
        "publish_date": "明治44年10月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 402,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第696號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 8,
        "publish_day": 17,
        "publish_date": "大正12年8月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 403,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1641號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 10,
        "publish_day": 25,
        "publish_date": "昭和14年10月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 404,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第356號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 5,
        "publish_day": 23,
        "publish_date": "大正8年5月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 405,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第243號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 3,
        "publish_day": 23,
        "publish_date": "大正6年3月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 406,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第255號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 6,
        "publish_day": 18,
        "publish_date": "昭和4年6月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 407,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1616號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 8,
        "publish_day": 28,
        "publish_date": "昭和14年8月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 408,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第14號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1911,
        "publish_month": 8,
        "publish_day": 11,
        "publish_date": "明治44年8月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 409,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第234號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 1,
        "publish_day": 19,
        "publish_date": "大正6年1月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 410,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1636號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 10,
        "publish_day": 13,
        "publish_date": "昭和14年10月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 411,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第479號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 7,
        "publish_day": 1,
        "publish_date": "大正10年7月1日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 412,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第376號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 10,
        "publish_day": 10,
        "publish_date": "大正8年10月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 413,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1620號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 9,
        "publish_day": 6,
        "publish_date": "昭和14年9月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 414,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第480號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 7,
        "publish_day": 5,
        "publish_date": "大正10年7月5日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 415,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第48號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 6,
        "publish_day": 27,
        "publish_date": "大正2年6月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 416,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第360號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 6,
        "publish_day": 20,
        "publish_date": "大正8年6月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 417,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第21號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1912,
        "publish_month": 12,
        "publish_day": 20,
        "publish_date": "大正元年12月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 418,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第84號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 3,
        "publish_day": 6,
        "publish_date": "大正3年3月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 419,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1911,
        "publish_month": 5,
        "publish_day": 19,
        "publish_date": "明治44年5月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 420,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第337號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 1,
        "publish_day": 10,
        "publish_date": "大正8年1月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 421,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "號外",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 10,
        "publish_day": 27,
        "publish_date": "大正8年10月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 422,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第506號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 10,
        "publish_day": 4,
        "publish_date": "大正10年10月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 423,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第33號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 3,
        "publish_day": 14,
        "publish_date": "大正2年3月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 424,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第44號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 5,
        "publish_day": 31,
        "publish_date": "昭和2年5月31日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 425,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第25號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 1,
        "publish_day": 17,
        "publish_date": "大正2年1月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 426,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第675號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 6,
        "publish_day": 5,
        "publish_date": "大正12年6月5日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 427,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第730號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 12,
        "publish_day": 14,
        "publish_date": "大正12年12月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 428,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第52號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 6,
        "publish_day": 28,
        "publish_date": "昭和2年6月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 429,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第510號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 10,
        "publish_day": 18,
        "publish_date": "大正10年10月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 430,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第511號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 10,
        "publish_day": 21,
        "publish_date": "大正10年10月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 431,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第258號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 6,
        "publish_day": 28,
        "publish_date": "昭和4年6月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 432,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第24號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 1,
        "publish_day": 10,
        "publish_date": "大正2年1月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 433,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第674號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 6,
        "publish_day": 1,
        "publish_date": "大正12年6月1日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 434,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第731號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 12,
        "publish_day": 18,
        "publish_date": "大正12年12月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 435,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第53號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 7,
        "publish_day": 1,
        "publish_date": "昭和2年7月1日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 436,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第32號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 3,
        "publish_day": 7,
        "publish_date": "大正2年3月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 437,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第45號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 6,
        "publish_day": 3,
        "publish_date": "昭和2年6月3日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 438,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第727號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 12,
        "publish_day": 4,
        "publish_date": "大正12年12月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 439,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第507號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 10,
        "publish_day": 7,
        "publish_date": "大正10年10月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 440,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第336號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 1,
        "publish_day": 3,
        "publish_date": "大正8年1月3日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 441,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第20號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1912,
        "publish_month": 12,
        "publish_day": 13,
        "publish_date": "大正元年12月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 442,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第85號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 3,
        "publish_day": 13,
        "publish_date": "大正3年3月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 443,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第3號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1911,
        "publish_month": 5,
        "publish_day": 26,
        "publish_date": "明治44年5月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 444,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第481號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 7,
        "publish_day": 8,
        "publish_date": "大正10年7月8日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 445,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第361號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 6,
        "publish_day": 27,
        "publish_date": "大正8年6月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 446,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第478號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 6,
        "publish_day": 28,
        "publish_date": "大正10年6月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 447,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第377號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 10,
        "publish_day": 17,
        "publish_date": "大正8年10月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 448,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第497號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 9,
        "publish_day": 2,
        "publish_date": "大正10年9月2日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 449,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1637號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 10,
        "publish_day": 16,
        "publish_date": "昭和14年10月16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 450,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第235號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 1,
        "publish_day": 26,
        "publish_date": "大正6年1月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 451,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第15號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1911,
        "publish_month": 8,
        "publish_day": 18,
        "publish_date": "明治44年8月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 452,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第47號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1912,
        "publish_month": 3,
        "publish_day": 29,
        "publish_date": "明治45年3月29日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 453,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第254號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 6,
        "publish_day": 14,
        "publish_date": "昭和4年6月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 454,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1617號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 8,
        "publish_day": 30,
        "publish_date": "昭和14年8月30日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 455,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第357號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 5,
        "publish_day": 30,
        "publish_date": "大正8年5月30日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 456,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第242號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 3,
        "publish_day": 16,
        "publish_date": "大正6年3月16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 457,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1640號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 10,
        "publish_day": 23,
        "publish_date": "昭和14年10月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 458,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第16號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1912,
        "publish_month": 11,
        "publish_day": 15,
        "publish_date": "大正元年11月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 459,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第678號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 6,
        "publish_day": 15,
        "publish_date": "大正12年6月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 460,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第28號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 2,
        "publish_day": 7,
        "publish_date": "大正2年2月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 461,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第23號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1911,
        "publish_month": 10,
        "publish_day": 13,
        "publish_date": "明治44年10月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 462,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第681號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 6,
        "publish_day": 26,
        "publish_date": "大正12年6月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 463,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1010號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1926,
        "publish_month": 9,
        "publish_day": 1,
        "publish_date": "大正15年9月1日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 464,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第49號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 6,
        "publish_day": 17,
        "publish_date": "昭和2年6月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 465,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第242號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 5,
        "publish_day": 3,
        "publish_date": "昭和4年5月3日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 466,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第51號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1912,
        "publish_month": 4,
        "publish_day": 26,
        "publish_date": "明治45年4月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 467,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1601號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 7,
        "publish_day": 24,
        "publish_date": "昭和14年7月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 468,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第341號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 2,
        "publish_day": 7,
        "publish_date": "大正8年2月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 469,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第462號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 5,
        "publish_day": 3,
        "publish_date": "大正10年5月3日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 470,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第180號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 1,
        "publish_day": 7,
        "publish_date": "大正5年1月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 471,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第382號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1919,
        "publish_month": 11,
        "publish_day": 21,
        "publish_date": "大正8年11月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 472,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第45號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 6,
        "publish_day": 6,
        "publish_date": "大正2年6月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 473,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第527號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 12,
        "publish_day": 16,
        "publish_date": "大正10年12月16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 474,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第474號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 6,
        "publish_day": 14,
        "publish_date": "大正10年6月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 475,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第239號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 2,
        "publish_day": 23,
        "publish_date": "大正6年2月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 476,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1331號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 10,
        "publish_day": 18,
        "publish_date": "昭和12年10月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 477,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1274號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 6,
        "publish_day": 7,
        "publish_date": "昭和12年6月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 478,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第623號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1933,
        "publish_month": 1,
        "publish_day": 24,
        "publish_date": "昭和8年1月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 479,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1223號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 2,
        "publish_day": 8,
        "publish_date": "昭和12年2月8日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 480,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第216號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 2,
        "publish_day": 1,
        "publish_date": "昭和4年2月1日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 481,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1327號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 10,
        "publish_day": 8,
        "publish_date": "昭和12年10月8日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 482,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第647號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1933,
        "publish_month": 4,
        "publish_day": 18,
        "publish_date": "昭和8年4月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 483,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1262號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 5,
        "publish_day": 10,
        "publish_date": "昭和12年5月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 484,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第241號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 4,
        "publish_day": 30,
        "publish_date": "昭和4年4月30日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 485,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1219號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 1,
        "publish_day": 29,
        "publish_date": "昭和12年1月29日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 486,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第120號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 11,
        "publish_day": 13,
        "publish_date": "大正3年11月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 487,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第335號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 4,
        "publish_day": 1,
        "publish_date": "昭和5年4月1日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 488,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第641號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 2,
        "publish_day": 6,
        "publish_date": "大正12年2月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 489,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1198號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 12,
        "publish_day": 7,
        "publish_date": "昭和11年12月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 490,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1177號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 10,
        "publish_day": 19,
        "publish_date": "昭和11年10月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 491,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第619號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1933,
        "publish_month": 1,
        "publish_day": 10,
        "publish_date": "昭和8年1月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 492,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第31號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 4,
        "publish_day": 15,
        "publish_date": "昭和2年4月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 493,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第461號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 4,
        "publish_day": 29,
        "publish_date": "大正10年4月29日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 494,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第27號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 4,
        "publish_day": 1,
        "publish_date": "昭和2年4月1日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 495,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第323號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 2,
        "publish_day": 18,
        "publish_date": "昭和5年2月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 496,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第657號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 4,
        "publish_day": 4,
        "publish_date": "大正12年4月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 497,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第457號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 4,
        "publish_day": 15,
        "publish_date": "大正10年4月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 498,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第7號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 1,
        "publish_day": 21,
        "publish_date": "昭和2年1月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 499,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第70號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 11,
        "publish_day": 28,
        "publish_date": "大正2年11月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 500,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1297號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 7,
        "publish_day": 30,
        "publish_date": "昭和12年7月30日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 501,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1141號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 7,
        "publish_day": 27,
        "publish_date": "昭和11年7月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 502,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1278號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 6,
        "publish_day": 16,
        "publish_date": "昭和12年6月16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 503,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第116號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 10,
        "publish_day": 16,
        "publish_date": "大正3年10月16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 504,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第100號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 6,
        "publish_day": 26,
        "publish_date": "大正3年6月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 505,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第315號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 1,
        "publish_day": 21,
        "publish_date": "昭和5年1月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 506,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1239號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 3,
        "publish_day": 17,
        "publish_date": "昭和12年3月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 507,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第11號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 2,
        "publish_day": 4,
        "publish_date": "昭和2年2月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 508,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第441號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 1,
        "publish_day": 7,
        "publish_date": "大正10年1月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 509,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第66號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 10,
        "publish_day": 31,
        "publish_date": "大正2年10月31日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 510,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第636號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 1,
        "publish_day": 19,
        "publish_date": "大正12年1月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 511,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1157號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 9,
        "publish_day": 2,
        "publish_date": "昭和11年9月2日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 512,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1281號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 6,
        "publish_day": 23,
        "publish_date": "昭和12年6月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 513,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第342號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 4,
        "publish_day": 25,
        "publish_date": "昭和5年4月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 514,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1205號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 12,
        "publish_day": 23,
        "publish_date": "昭和11年12月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 515,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第642號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1933,
        "publish_month": 3,
        "publish_day": 31,
        "publish_date": "昭和8年3月31日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 516,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第236號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 4,
        "publish_day": 12,
        "publish_date": "昭和4年4月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 517,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1215號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 1,
        "publish_day": 20,
        "publish_date": "昭和12年1月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 518,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第339號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 4,
        "publish_day": 15,
        "publish_date": "昭和5年4月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 519,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1350號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 12,
        "publish_day": 1,
        "publish_date": "昭和12年12月1日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 520,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第667號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1933,
        "publish_month": 6,
        "publish_day": 27,
        "publish_date": "昭和8年6月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 521,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1254號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 4,
        "publish_day": 21,
        "publish_date": "昭和12年4月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 522,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1182號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 10,
        "publish_day": 30,
        "publish_date": "昭和11年10月30日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 523,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1311號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 9,
        "publish_day": 1,
        "publish_date": "昭和12年9月1日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 524,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第220號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 2,
        "publish_day": 15,
        "publish_date": "昭和4年2月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 525,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1346號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 11,
        "publish_day": 22,
        "publish_date": "昭和12年11月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 526,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第221號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 2,
        "publish_day": 19,
        "publish_date": "昭和4年2月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 527,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1347號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 11,
        "publish_day": 24,
        "publish_date": "昭和12年11月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 528,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1255號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 4,
        "publish_day": 23,
        "publish_date": "昭和12年4月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 529,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1183號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 11,
        "publish_day": 2,
        "publish_date": "昭和11年11月2日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 530,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1195號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 11,
        "publish_day": 30,
        "publish_date": "昭和11年11月30日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 531,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1243號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 3,
        "publish_day": 26,
        "publish_date": "昭和12年3月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 532,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1306號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 8,
        "publish_day": 20,
        "publish_date": "昭和12年8月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 533,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第666號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1933,
        "publish_month": 6,
        "publish_day": 23,
        "publish_date": "昭和8年6月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 534,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第237號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 4,
        "publish_day": 16,
        "publish_date": "昭和4年4月16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 535,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1214號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 1,
        "publish_day": 18,
        "publish_date": "昭和12年1月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 536,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第338號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 4,
        "publish_day": 11,
        "publish_date": "昭和5年4月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 537,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1351號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 12,
        "publish_day": 3,
        "publish_date": "昭和12年12月3日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 538,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1156號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 8,
        "publish_day": 31,
        "publish_date": "昭和11年8月31日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 539,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1280號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 6,
        "publish_day": 21,
        "publish_date": "昭和12年6月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 540,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第343號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 4,
        "publish_day": 30,
        "publish_date": "昭和5年4月30日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 541,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第10號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 2,
        "publish_day": 1,
        "publish_date": "昭和2年2月1日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 542,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第67號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 11,
        "publish_day": 7,
        "publish_date": "大正2年11月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 543,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第637號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 1,
        "publish_day": 23,
        "publish_date": "大正12年1月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 544,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第314號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 1,
        "publish_day": 17,
        "publish_date": "昭和5年1月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 545,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1238號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 3,
        "publish_day": 15,
        "publish_date": "昭和12年3月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 546,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第660號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 4,
        "publish_day": 13,
        "publish_date": "大正12年4月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 547,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第117號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 10,
        "publish_day": 23,
        "publish_date": "大正3年10月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 548,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1140號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 7,
        "publish_day": 22,
        "publish_date": "昭和11年7月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 549,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1279號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 6,
        "publish_day": 18,
        "publish_date": "昭和12年6月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 550,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第456號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 4,
        "publish_day": 12,
        "publish_date": "大正10年4月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 551,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第6號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 1,
        "publish_day": 18,
        "publish_date": "昭和2年1月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 552,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第71號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 12,
        "publish_day": 5,
        "publish_date": "大正2年12月5日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 553,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第656號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 3,
        "publish_day": 30,
        "publish_date": "大正12年3月30日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 554,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1412號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 5,
        "publish_day": 4,
        "publish_date": "昭和13年5月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 555,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第322號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 2,
        "publish_day": 14,
        "publish_date": "昭和5年2月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 556,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第26號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 3,
        "publish_day": 29,
        "publish_date": "昭和2年3月29日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 557,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1160號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 9,
        "publish_day": 9,
        "publish_date": "昭和11年9月9日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 558,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第618號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1933,
        "publish_month": 1,
        "publish_day": 6,
        "publish_date": "昭和8年1月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 559,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第30號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 4,
        "publish_day": 12,
        "publish_date": "昭和2年4月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 560,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1199號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 12,
        "publish_day": 9,
        "publish_date": "昭和11年12月9日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 561,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第640號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 2,
        "publish_day": 2,
        "publish_date": "大正12年2月2日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 562,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第121號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 11,
        "publish_day": 20,
        "publish_date": "大正3年11月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 563,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1326號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 10,
        "publish_day": 6,
        "publish_date": "昭和12年10月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 564,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第646號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1933,
        "publish_month": 4,
        "publish_day": 14,
        "publish_date": "昭和8年4月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 565,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1263號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 5,
        "publish_day": 12,
        "publish_date": "昭和12年5月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 566,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第240號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 4,
        "publish_day": 26,
        "publish_date": "昭和4年4月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 567,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第318號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 1,
        "publish_day": 31,
        "publish_date": "昭和5年1月31日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 568,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第217號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 2,
        "publish_day": 5,
        "publish_date": "昭和4年2月5日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 569,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1234號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 3,
        "publish_day": 5,
        "publish_date": "昭和12年3月5日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 570,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1222號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 2,
        "publish_day": 5,
        "publish_date": "昭和12年2月5日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 571,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第650號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1933,
        "publish_month": 4,
        "publish_day": 28,
        "publish_date": "昭和8年4月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 572,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1275號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 6,
        "publish_day": 9,
        "publish_date": "昭和12年6月9日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 573,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第451號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 3,
        "publish_day": 18,
        "publish_date": "大正10年3月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 574,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第629號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1933,
        "publish_month": 2,
        "publish_day": 14,
        "publish_date": "昭和8年2月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 575,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1291號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 7,
        "publish_day": 16,
        "publish_date": "昭和12年7月16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 576,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第110號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 9,
        "publish_day": 4,
        "publish_date": "大正3年9月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 577,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第106號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 8,
        "publish_day": 7,
        "publish_date": "大正3年8月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 578,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第313號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 1,
        "publish_day": 14,
        "publish_date": "昭和5年1月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 579,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第17號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 2,
        "publish_day": 25,
        "publish_date": "昭和2年2月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 580,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第60號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 9,
        "publish_day": 19,
        "publish_date": "大正2年9月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 581,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1287號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 7,
        "publish_day": 7,
        "publish_date": "昭和12年7月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 582,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1151號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 8,
        "publish_day": 19,
        "publish_date": "昭和11年8月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 583,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1268號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 5,
        "publish_day": 24,
        "publish_date": "昭和12年5月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 584,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1203號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 12,
        "publish_day": 18,
        "publish_date": "昭和11年12月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 585,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第230號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 3,
        "publish_day": 22,
        "publish_date": "昭和4年3月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 586,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1213號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 1,
        "publish_day": 15,
        "publish_date": "昭和12年1月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 587,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1356號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 12,
        "publish_day": 15,
        "publish_date": "昭和12年12月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 588,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第661號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1933,
        "publish_month": 6,
        "publish_day": 6,
        "publish_date": "昭和8年6月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 589,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1301號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 8,
        "publish_day": 9,
        "publish_date": "昭和12年8月9日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 590,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1252號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 4,
        "publish_day": 16,
        "publish_date": "昭和12年4月16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 591,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1317號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 9,
        "publish_day": 15,
        "publish_date": "昭和12年9月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 592,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第226號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 3,
        "publish_day": 8,
        "publish_date": "昭和4年3月8日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 593,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第96號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 5,
        "publish_day": 26,
        "publish_date": "大正3年5月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 594,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第329號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 3,
        "publish_day": 11,
        "publish_date": "昭和5年3月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 595,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1337號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 11,
        "publish_day": 1,
        "publish_date": "昭和12年11月1日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 596,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第657號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1933,
        "publish_month": 5,
        "publish_day": 23,
        "publish_date": "昭和8年5月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 597,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1272號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 6,
        "publish_day": 2,
        "publish_date": "昭和12年6月2日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 598,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第625號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1933,
        "publish_month": 1,
        "publish_day": 31,
        "publish_date": "昭和8年1月31日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 599,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1360號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 12,
        "publish_day": 24,
        "publish_date": "昭和12年12月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 600,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第210號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 1,
        "publish_day": 11,
        "publish_date": "昭和4年1月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 601,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1321號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 9,
        "publish_day": 24,
        "publish_date": "昭和12年9月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 602,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1264號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 5,
        "publish_day": 14,
        "publish_date": "昭和12年5月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 603,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第126號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 12,
        "publish_day": 25,
        "publish_date": "大正3年12月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 604,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第333號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 3,
        "publish_day": 25,
        "publish_date": "昭和5年3月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 605,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第647號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 2,
        "publish_day": 27,
        "publish_date": "大正12年2月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 606,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1171號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 10,
        "publish_day": 5,
        "publish_date": "昭和11年10月5日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 607,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1167號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 9,
        "publish_day": 25,
        "publish_date": "昭和11年9月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 608,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第21號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 3,
        "publish_day": 11,
        "publish_date": "昭和2年3月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 609,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第325號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 2,
        "publish_day": 25,
        "publish_date": "昭和5年2月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 610,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1415號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 5,
        "publish_day": 11,
        "publish_date": "昭和13年5月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 611,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1130號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 7,
        "publish_day": 1,
        "publish_date": "昭和11年7月1日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 612,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第650號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 3,
        "publish_day": 9,
        "publish_date": "大正12年3月9日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 613,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1208號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 1,
        "publish_day": 4,
        "publish_date": "昭和12年1月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 614,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第324號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 2,
        "publish_day": 21,
        "publish_date": "昭和5年2月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 615,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1414號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 5,
        "publish_day": 9,
        "publish_date": "昭和13年5月9日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 616,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1131號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 7,
        "publish_day": 3,
        "publish_date": "昭和11年7月3日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 617,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第20號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 3,
        "publish_day": 8,
        "publish_date": "昭和2年3月8日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 618,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1189號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 11,
        "publish_day": 16,
        "publish_date": "昭和11年11月16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 619,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1166號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 9,
        "publish_day": 24,
        "publish_date": "昭和11年9月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 620,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1249號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 4,
        "publish_day": 9,
        "publish_date": "昭和12年4月9日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 621,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1170號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 10,
        "publish_day": 2,
        "publish_date": "昭和11年10月2日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 622,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第646號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 2,
        "publish_day": 23,
        "publish_date": "大正12年2月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 623,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第332號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 3,
        "publish_day": 22,
        "publish_date": "昭和5年3月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 624,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第211號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 1,
        "publish_day": 15,
        "publish_date": "昭和4年1月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 625,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1361號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 12,
        "publish_day": 27,
        "publish_date": "昭和12年12月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 626,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1224號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 2,
        "publish_day": 10,
        "publish_date": "昭和12年2月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 627,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第624號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1933,
        "publish_month": 1,
        "publish_day": 27,
        "publish_date": "昭和8年1月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 628,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第656號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1933,
        "publish_month": 5,
        "publish_day": 19,
        "publish_date": "昭和8年5月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 629,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1273號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 6,
        "publish_day": 4,
        "publish_date": "昭和12年6月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 630,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第227號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 3,
        "publish_day": 12,
        "publish_date": "昭和4年3月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 631,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1418號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 5,
        "publish_day": 18,
        "publish_date": "昭和13年5月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 632,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第97號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 6,
        "publish_day": 5,
        "publish_date": "大正3年6月5日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 633,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第328號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 3,
        "publish_day": 7,
        "publish_date": "昭和5年3月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 634,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1185號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 11,
        "publish_day": 6,
        "publish_date": "昭和11年11月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 635,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1253號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 4,
        "publish_day": 19,
        "publish_date": "昭和12年4月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 636,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1316號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 9,
        "publish_day": 13,
        "publish_date": "昭和12年9月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 637,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1193號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 11,
        "publish_day": 25,
        "publish_date": "昭和11年11月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 638,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第660號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1933,
        "publish_month": 6,
        "publish_day": 2,
        "publish_date": "昭和8年6月2日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 639,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1300號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 8,
        "publish_day": 6,
        "publish_date": "昭和12年8月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 640,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第231號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 3,
        "publish_day": 26,
        "publish_date": "昭和4年3月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 641,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1212號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 1,
        "publish_day": 13,
        "publish_date": "昭和12年1月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 642,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1357號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 12,
        "publish_day": 17,
        "publish_date": "昭和12年12月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 643,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1202號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 12,
        "publish_day": 16,
        "publish_date": "昭和11年12月16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 644,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1286號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 7,
        "publish_day": 5,
        "publish_date": "昭和12年7月5日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 645,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1150號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 8,
        "publish_day": 17,
        "publish_date": "昭和11年8月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 646,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1269號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 5,
        "publish_day": 26,
        "publish_date": "昭和12年5月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 647,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第446號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 2,
        "publish_day": 11,
        "publish_date": "大正10年2月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 648,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第16號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 2,
        "publish_day": 22,
        "publish_date": "昭和2年2月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 649,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第61號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 9,
        "publish_day": 26,
        "publish_date": "大正2年9月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 650,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第312號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 1,
        "publish_day": 10,
        "publish_date": "昭和5年1月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 651,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第107號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 8,
        "publish_day": 14,
        "publish_date": "大正3年8月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 652,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第111號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 9,
        "publish_day": 11,
        "publish_date": "大正3年9月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 653,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1228號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 2,
        "publish_day": 19,
        "publish_date": "昭和12年2月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 654,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1146號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 8,
        "publish_day": 7,
        "publish_date": "昭和11年8月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 655,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1290號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 7,
        "publish_day": 14,
        "publish_date": "昭和12年7月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 656,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第450號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 3,
        "publish_day": 11,
        "publish_date": "大正10年3月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 657,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第94號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 5,
        "publish_day": 15,
        "publish_date": "大正3年5月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 658,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1342號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 11,
        "publish_day": 12,
        "publish_date": "昭和12年11月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 659,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第224號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 3,
        "publish_day": 1,
        "publish_date": "昭和4年3月1日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 660,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1315號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 9,
        "publish_day": 10,
        "publish_date": "昭和12年9月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 661,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1250號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 4,
        "publish_day": 12,
        "publish_date": "昭和12年4月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 662,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1186號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 11,
        "publish_day": 9,
        "publish_date": "昭和11年11月9日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 663,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第663號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1933,
        "publish_month": 6,
        "publish_day": 13,
        "publish_date": "昭和8年6月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 664,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1303號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 8,
        "publish_day": 13,
        "publish_date": "昭和12年8月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 665,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1190號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 11,
        "publish_day": 18,
        "publish_date": "昭和11年11月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 666,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第232號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 3,
        "publish_day": 29,
        "publish_date": "昭和4年3月29日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 667,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1211號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 1,
        "publish_day": 11,
        "publish_date": "昭和12年1月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 668,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1201號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 12,
        "publish_day": 14,
        "publish_date": "昭和11年12月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 669,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第649號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 3,
        "publish_day": 6,
        "publish_date": "大正12年3月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 670,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1153號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 8,
        "publish_day": 24,
        "publish_date": "昭和11年8月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 671,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1285號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 7,
        "publish_day": 2,
        "publish_date": "昭和12年7月2日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 672,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第62號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 10,
        "publish_day": 3,
        "publish_date": "大正2年10月3日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 673,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第632號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 1,
        "publish_day": 4,
        "publish_date": "大正12年1月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 674,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第15號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 2,
        "publish_day": 18,
        "publish_date": "昭和2年2月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 675,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第445號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 2,
        "publish_day": 4,
        "publish_date": "大正10年2月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 676,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第311號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 1,
        "publish_day": 7,
        "publish_date": "昭和5年1月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 677,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第104號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 7,
        "publish_day": 24,
        "publish_date": "大正3年7月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 678,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第112號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 9,
        "publish_day": 18,
        "publish_date": "大正3年9月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 679,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第659號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1933,
        "publish_month": 5,
        "publish_day": 30,
        "publish_date": "昭和8年5月30日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 680,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1339號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 11,
        "publish_day": 5,
        "publish_date": "昭和12年11月5日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 681,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1293號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 7,
        "publish_day": 21,
        "publish_date": "昭和12年7月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 682,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1145號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 8,
        "publish_day": 3,
        "publish_date": "昭和11年8月3日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 683,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第74號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 12,
        "publish_day": 26,
        "publish_date": "大正2年12月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 684,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第453號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 4,
        "publish_day": 1,
        "publish_date": "大正10年4月1日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 685,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第3號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 1,
        "publish_day": 7,
        "publish_date": "昭和2年1月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 686,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第327號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 3,
        "publish_day": 4,
        "publish_date": "昭和5年3月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 687,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第98號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 6,
        "publish_day": 12,
        "publish_date": "大正3年6月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 688,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第228號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 3,
        "publish_day": 15,
        "publish_date": "昭和4年3月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 689,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第23號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 3,
        "publish_day": 18,
        "publish_date": "昭和2年3月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 690,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1319號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 9,
        "publish_day": 20,
        "publish_date": "昭和12年9月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 691,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1165號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 9,
        "publish_day": 21,
        "publish_date": "昭和11年9月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 692,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第35號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 4,
        "publish_day": 30,
        "publish_date": "昭和2年4月30日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 693,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1173號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 10,
        "publish_day": 9,
        "publish_date": "昭和11年10月9日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 694,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第645號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 2,
        "publish_day": 20,
        "publish_date": "大正12年2月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 695,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1358號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 12,
        "publish_day": 20,
        "publish_date": "昭和12年12月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 696,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第331號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 3,
        "publish_day": 18,
        "publish_date": "昭和5年3月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 697,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第124號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 12,
        "publish_day": 11,
        "publish_date": "大正3年12月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 698,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第449號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 3,
        "publish_day": 4,
        "publish_date": "大正10年3月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 699,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第19號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 3,
        "publish_day": 4,
        "publish_date": "昭和2年3月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 700,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1266號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 5,
        "publish_day": 19,
        "publish_date": "昭和12年5月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 701,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第643號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1933,
        "publish_month": 4,
        "publish_day": 4,
        "publish_date": "昭和8年4月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 702,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1323號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 9,
        "publish_day": 29,
        "publish_date": "昭和12年9月29日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 703,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1289號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 7,
        "publish_day": 12,
        "publish_date": "昭和12年7月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 704,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第212號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 1,
        "publish_day": 18,
        "publish_date": "昭和4年1月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 705,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1231號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 2,
        "publish_day": 26,
        "publish_date": "昭和12年2月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 706,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第108號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 8,
        "publish_day": 21,
        "publish_date": "大正3年8月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 707,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1227號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 2,
        "publish_day": 17,
        "publish_date": "昭和12年2月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 708,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第627號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1933,
        "publish_month": 2,
        "publish_day": 7,
        "publish_date": "昭和8年2月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 709,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1270號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 5,
        "publish_day": 28,
        "publish_date": "昭和12年5月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 710,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1149號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 8,
        "publish_day": 14,
        "publish_date": "昭和11年8月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 711,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1335號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 10,
        "publish_day": 27,
        "publish_date": "昭和12年10月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 712,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第655號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1933,
        "publish_month": 5,
        "publish_day": 16,
        "publish_date": "昭和8年5月16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 713,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1271號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 5,
        "publish_day": 31,
        "publish_date": "昭和12年5月31日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 714,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1148號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 8,
        "publish_day": 12,
        "publish_date": "昭和11年8月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 715,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1334號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 10,
        "publish_day": 25,
        "publish_date": "昭和12年10月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 716,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第654號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1933,
        "publish_month": 5,
        "publish_day": 12,
        "publish_date": "昭和8年5月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 717,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第626號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1933,
        "publish_month": 2,
        "publish_day": 3,
        "publish_date": "昭和8年2月3日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 718,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1226號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 2,
        "publish_day": 15,
        "publish_date": "昭和12年2月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 719,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第213號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 1,
        "publish_day": 22,
        "publish_date": "昭和4年1月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 720,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1230號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 2,
        "publish_day": 24,
        "publish_date": "昭和12年2月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 721,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第109號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 8,
        "publish_day": 28,
        "publish_date": "大正3年8月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 722,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1322號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 9,
        "publish_day": 27,
        "publish_date": "昭和12年9月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 723,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第448號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 2,
        "publish_day": 25,
        "publish_date": "大正10年2月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 724,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第18號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 3,
        "publish_day": 1,
        "publish_date": "昭和2年3月1日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 725,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1359號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 12,
        "publish_day": 22,
        "publish_date": "昭和12年12月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 726,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第125號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 12,
        "publish_day": 18,
        "publish_date": "大正3年12月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 727,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第330號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 3,
        "publish_day": 14,
        "publish_date": "昭和5年3月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 728,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第644號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 2,
        "publish_day": 16,
        "publish_date": "大正12年2月16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 729,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1172號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 10,
        "publish_day": 7,
        "publish_date": "昭和11年10月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 730,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第34號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 4,
        "publish_day": 26,
        "publish_date": "昭和2年4月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 731,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1318號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 9,
        "publish_day": 17,
        "publish_date": "昭和12年9月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 732,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1164號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 9,
        "publish_day": 18,
        "publish_date": "昭和11年9月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 733,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第22號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 3,
        "publish_day": 15,
        "publish_date": "昭和2年3月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 734,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1416號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 5,
        "publish_day": 13,
        "publish_date": "昭和13年5月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 735,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第326號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 2,
        "publish_day": 28,
        "publish_date": "昭和5年2月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 736,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第99號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 6,
        "publish_day": 19,
        "publish_date": "大正3年6月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 737,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第229號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 3,
        "publish_day": 19,
        "publish_date": "昭和4年3月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 738,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第652號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 3,
        "publish_day": 16,
        "publish_date": "大正12年3月16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 739,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第452號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 3,
        "publish_day": 25,
        "publish_date": "大正10年3月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 740,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第658號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1933,
        "publish_month": 5,
        "publish_day": 26,
        "publish_date": "昭和8年5月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 741,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1338號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 11,
        "publish_day": 4,
        "publish_date": "昭和12年11月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 742,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1292號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 7,
        "publish_day": 19,
        "publish_date": "昭和12年7月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 743,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1144號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 8,
        "publish_day": 3,
        "publish_date": "昭和11年8月3日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 744,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第664號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 4,
        "publish_day": 27,
        "publish_date": "大正12年4月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 745,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第105號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 7,
        "publish_day": 31,
        "publish_date": "大正3年7月31日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 746,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第63號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 10,
        "publish_day": 10,
        "publish_date": "大正2年10月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 747,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第633號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 1,
        "publish_day": 9,
        "publish_date": "大正12年1月9日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 748,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第14號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 2,
        "publish_day": 15,
        "publish_date": "昭和2年2月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 749,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第444號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 1,
        "publish_day": 28,
        "publish_date": "大正10年1月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 750,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1152號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 8,
        "publish_day": 21,
        "publish_date": "昭和11年8月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 751,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1284號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 6,
        "publish_day": 30,
        "publish_date": "昭和12年6月30日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 752,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第648號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 3,
        "publish_day": 2,
        "publish_date": "大正12年3月2日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 753,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1355號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 12,
        "publish_day": 13,
        "publish_date": "昭和12年12月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 754,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第233號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 4,
        "publish_day": 2,
        "publish_date": "昭和4年4月2日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 755,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第662號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1933,
        "publish_month": 6,
        "publish_day": 9,
        "publish_date": "昭和8年6月9日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 756,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1302號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 8,
        "publish_day": 11,
        "publish_date": "昭和12年8月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 757,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1247號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 4,
        "publish_day": 5,
        "publish_date": "昭和12年4月5日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 758,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1168號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 9,
        "publish_day": 28,
        "publish_date": "昭和11年9月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 759,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1314號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 9,
        "publish_day": 8,
        "publish_date": "昭和12年9月8日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 760,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1251號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 4,
        "publish_day": 14,
        "publish_date": "昭和12年4月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 761,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1187號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 11,
        "publish_day": 11,
        "publish_date": "昭和11年11月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 762,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第95號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 5,
        "publish_day": 22,
        "publish_date": "大正3年5月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 763,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第225號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 3,
        "publish_day": 5,
        "publish_date": "昭和4年3月5日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 764,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第655號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 3,
        "publish_day": 27,
        "publish_date": "大正12年3月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 765,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第321號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 2,
        "publish_day": 12,
        "publish_date": "昭和5年2月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 766,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1134號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 7,
        "publish_day": 10,
        "publish_date": "昭和11年7月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 767,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第25號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 3,
        "publish_day": 25,
        "publish_date": "昭和2年3月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 768,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1163號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 9,
        "publish_day": 16,
        "publish_date": "昭和11年9月16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 769,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第33號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 4,
        "publish_day": 22,
        "publish_date": "昭和2年4月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 770,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1309號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 8,
        "publish_day": 27,
        "publish_date": "昭和12年8月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 771,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1175號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 10,
        "publish_day": 14,
        "publish_date": "昭和11年10月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 772,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第643號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 2,
        "publish_day": 13,
        "publish_date": "大正12年2月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 773,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第238號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 4,
        "publish_day": 19,
        "publish_date": "昭和4年4月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 774,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第68號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 11,
        "publish_day": 14,
        "publish_date": "大正2年11月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 775,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1260號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 5,
        "publish_day": 5,
        "publish_date": "昭和12年5月5日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 776,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1159號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 9,
        "publish_day": 7,
        "publish_date": "昭和11年9月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 777,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1325號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 10,
        "publish_day": 4,
        "publish_date": "昭和12年10月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 778,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第645號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1933,
        "publish_month": 4,
        "publish_day": 11,
        "publish_date": "昭和8年4月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 779,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第214號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 1,
        "publish_day": 25,
        "publish_date": "昭和4年1月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 780,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1237號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 3,
        "publish_day": 12,
        "publish_date": "昭和12年3月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 781,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1221號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 2,
        "publish_day": 3,
        "publish_date": "昭和12年2月3日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 782,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第118號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 10,
        "publish_day": 30,
        "publish_date": "大正3年10月30日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 783,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第621號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1933,
        "publish_month": 1,
        "publish_day": 17,
        "publish_date": "昭和8年1月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 784,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第459號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 4,
        "publish_day": 22,
        "publish_date": "大正10年4月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 785,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第9號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 1,
        "publish_day": 28,
        "publish_date": "昭和2年1月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 786,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1276號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 6,
        "publish_day": 11,
        "publish_date": "昭和12年6月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 787,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1299號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 8,
        "publish_day": 4,
        "publish_date": "昭和12年8月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 788,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第653號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1933,
        "publish_month": 5,
        "publish_day": 9,
        "publish_date": "昭和8年5月9日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 789,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1333號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 10,
        "publish_day": 22,
        "publish_date": "昭和12年10月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 790,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1138號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 7,
        "publish_day": 20,
        "publish_date": "昭和11年7月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 791,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1344號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 11,
        "publish_day": 17,
        "publish_date": "昭和12年11月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 792,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第92號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 5,
        "publish_day": 1,
        "publish_date": "大正3年5月1日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 793,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第222號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 2,
        "publish_day": 22,
        "publish_date": "昭和4年2月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 794,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1313號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 9,
        "publish_day": 6,
        "publish_date": "昭和12年9月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 795,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1180號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 10,
        "publish_day": 26,
        "publish_date": "昭和11年10月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 796,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第29號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 4,
        "publish_day": 8,
        "publish_date": "昭和2年4月8日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 797,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1179號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 10,
        "publish_day": 23,
        "publish_date": "昭和11年10月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 798,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第665號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1933,
        "publish_month": 6,
        "publish_day": 20,
        "publish_date": "昭和8年6月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 799,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1240號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 3,
        "publish_day": 19,
        "publish_date": "昭和12年3月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 800,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1196號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 12,
        "publish_day": 2,
        "publish_date": "昭和11年12月2日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 801,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1352號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 12,
        "publish_day": 6,
        "publish_date": "昭和12年12月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 802,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第234號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 4,
        "publish_day": 5,
        "publish_date": "昭和4年4月5日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 803,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1217號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 1,
        "publish_day": 25,
        "publish_date": "昭和12年1月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 804,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第640號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1933,
        "publish_month": 3,
        "publish_day": 24,
        "publish_date": "昭和8年3月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 805,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1207號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 12,
        "publish_day": 28,
        "publish_date": "昭和11年12月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 806,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第340號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 4,
        "publish_day": 18,
        "publish_date": "昭和5年4月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 807,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1329號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 10,
        "publish_day": 13,
        "publish_date": "昭和12年10月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 808,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1155號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 8,
        "publish_day": 28,
        "publish_date": "昭和11年8月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 809,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第64號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 10,
        "publish_day": 17,
        "publish_date": "大正2年10月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 810,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第634號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 1,
        "publish_day": 12,
        "publish_date": "大正12年1月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 811,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第443號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 1,
        "publish_day": 21,
        "publish_date": "大正10年1月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 812,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第13號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 2,
        "publish_day": 12,
        "publish_date": "昭和2年2月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 813,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第218號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 2,
        "publish_day": 8,
        "publish_date": "昭和4年2月8日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 814,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第317號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 1,
        "publish_day": 28,
        "publish_date": "昭和5年1月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 815,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第102號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 7,
        "publish_day": 10,
        "publish_date": "大正3年7月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 816,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第663號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 4,
        "publish_day": 24,
        "publish_date": "大正12年4月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 817,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第114號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 10,
        "publish_day": 3,
        "publish_date": "大正3年10月3日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 818,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1143號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 7,
        "publish_day": 31,
        "publish_date": "昭和11年7月31日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 819,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1295號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 7,
        "publish_day": 26,
        "publish_date": "昭和12年7月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 820,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第72號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 12,
        "publish_day": 12,
        "publish_date": "大正2年12月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 821,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第5號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 1,
        "publish_day": 14,
        "publish_date": "昭和2年1月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 822,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第73號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 12,
        "publish_day": 19,
        "publish_date": "大正2年12月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 823,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第4號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 1,
        "publish_day": 11,
        "publish_date": "昭和2年1月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 824,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1142號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 7,
        "publish_day": 29,
        "publish_date": "昭和11年7月29日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 825,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1294號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 7,
        "publish_day": 23,
        "publish_date": "昭和12年7月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 826,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第115號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 10,
        "publish_day": 9,
        "publish_date": "大正3年10月9日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 827,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第662號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 4,
        "publish_day": 20,
        "publish_date": "大正12年4月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 828,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第219號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 2,
        "publish_day": 12,
        "publish_date": "昭和4年2月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 829,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第103號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 7,
        "publish_day": 17,
        "publish_date": "大正3年7月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 830,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第316號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 1,
        "publish_day": 24,
        "publish_date": "昭和5年1月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 831,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第65號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 10,
        "publish_day": 17,
        "publish_date": "大正2年10月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 832,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第635號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 1,
        "publish_day": 16,
        "publish_date": "大正12年1月16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 833,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第442號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 1,
        "publish_day": 14,
        "publish_date": "大正10年1月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 834,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第12號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 2,
        "publish_day": 9,
        "publish_date": "昭和2年2月9日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 835,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1282號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 6,
        "publish_day": 25,
        "publish_date": "昭和12年6月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 836,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第341號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 4,
        "publish_day": 22,
        "publish_date": "昭和5年4月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 837,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第648號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1933,
        "publish_month": 4,
        "publish_day": 21,
        "publish_date": "昭和8年4月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 838,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1328號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 10,
        "publish_day": 11,
        "publish_date": "昭和12年10月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 839,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第641號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1933,
        "publish_month": 3,
        "publish_day": 28,
        "publish_date": "昭和8年3月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 840,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1353號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 12,
        "publish_day": 8,
        "publish_date": "昭和12年12月8日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 841,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1216號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 1,
        "publish_day": 22,
        "publish_date": "昭和12年1月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 842,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1178號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 10,
        "publish_day": 21,
        "publish_date": "昭和11年10月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 843,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1304號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 8,
        "publish_day": 16,
        "publish_date": "昭和12年8月16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 844,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第664號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1933,
        "publish_month": 6,
        "publish_day": 16,
        "publish_date": "昭和8年6月16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 845,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1241號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 3,
        "publish_day": 22,
        "publish_date": "昭和12年3月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 846,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1197號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 12,
        "publish_day": 4,
        "publish_date": "昭和11年12月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 847,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1312號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 9,
        "publish_day": 3,
        "publish_date": "昭和12年9月3日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 848,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第658號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 4,
        "publish_day": 6,
        "publish_date": "大正12年4月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 849,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1139號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 7,
        "publish_day": 22,
        "publish_date": "昭和11年7月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 850,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第93號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 5,
        "publish_day": 8,
        "publish_date": "大正3年5月8日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 851,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第223號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 2,
        "publish_day": 26,
        "publish_date": "昭和4年2月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 852,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1277號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 6,
        "publish_day": 14,
        "publish_date": "昭和12年6月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 853,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1298號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 8,
        "publish_day": 2,
        "publish_date": "昭和12年8月2日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 854,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第652號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1933,
        "publish_month": 5,
        "publish_day": 5,
        "publish_date": "昭和8年5月5日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 855,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1332號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 10,
        "publish_day": 20,
        "publish_date": "昭和12年10月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 856,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第620號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1933,
        "publish_month": 1,
        "publish_day": 13,
        "publish_date": "昭和8年1月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 857,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第458號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1921,
        "publish_month": 4,
        "publish_day": 19,
        "publish_date": "大正10年4月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 858,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第8號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 1,
        "publish_day": 25,
        "publish_date": "昭和2年1月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 859,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第119號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 11,
        "publish_day": 6,
        "publish_date": "大正3年11月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 860,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1236號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 3,
        "publish_day": 10,
        "publish_date": "昭和12年3月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 861,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1261號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 5,
        "publish_day": 7,
        "publish_date": "昭和12年5月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 862,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1158號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 9,
        "publish_day": 4,
        "publish_date": "昭和11年9月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 863,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1324號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 10,
        "publish_day": 2,
        "publish_date": "昭和12年10月2日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 864,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第639號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 1,
        "publish_day": 30,
        "publish_date": "大正12年1月30日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 865,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第69號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1913,
        "publish_month": 11,
        "publish_day": 21,
        "publish_date": "大正2年11月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 866,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第123號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1914,
        "publish_month": 12,
        "publish_day": 4,
        "publish_date": "大正3年12月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 867,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第239號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1929,
        "publish_month": 4,
        "publish_day": 23,
        "publish_date": "昭和4年4月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 868,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第642號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 2,
        "publish_day": 9,
        "publish_date": "大正12年2月9日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 869,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第668號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1933,
        "publish_month": 6,
        "publish_day": 30,
        "publish_date": "昭和8年6月30日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 870,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1308號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 8,
        "publish_day": 25,
        "publish_date": "昭和12年8月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 871,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1174號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 10,
        "publish_day": 12,
        "publish_date": "昭和11年10月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 872,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第32號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 4,
        "publish_day": 19,
        "publish_date": "昭和2年4月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 873,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1162號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 9,
        "publish_day": 14,
        "publish_date": "昭和11年9月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 874,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第24號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1927,
        "publish_month": 3,
        "publish_day": 22,
        "publish_date": "昭和2年3月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 875,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第320號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 2,
        "publish_day": 7,
        "publish_date": "昭和5年2月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 876,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1349號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1937,
        "publish_month": 11,
        "publish_day": 29,
        "publish_date": "昭和12年11月29日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 877,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1135號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1936,
        "publish_month": 7,
        "publish_day": 13,
        "publish_date": "昭和11年7月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 878,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第654號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1923,
        "publish_month": 3,
        "publish_day": 23,
        "publish_date": "大正12年3月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 879,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2103號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 11,
        "publish_day": 2,
        "publish_date": "昭和17年11月2日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 880,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第358號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 6,
        "publish_day": 20,
        "publish_date": "昭和5年6月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 881,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2046號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 6,
        "publish_day": 19,
        "publish_date": "昭和17年6月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 882,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1706號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 4,
        "publish_day": 4,
        "publish_date": "昭和15年4月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 883,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1829號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 1,
        "publish_day": 22,
        "publish_date": "昭和16年1月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 884,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第228號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 12,
        "publish_day": 8,
        "publish_date": "大正5年12月8日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 885,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第489號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1931,
        "publish_month": 9,
        "publish_day": 29,
        "publish_date": "昭和6年9月29日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 886,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第466號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1931,
        "publish_month": 7,
        "publish_day": 10,
        "publish_date": "昭和6年7月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 887,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2152號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 3,
        "publish_day": 5,
        "publish_date": "昭和18年3月5日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 888,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2287號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1944,
        "publish_month": 1,
        "publish_day": 24,
        "publish_date": "昭和19年1月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 889,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第257號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 6,
        "publish_day": 29,
        "publish_date": "大正6年6月29日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 890,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1679號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 1,
        "publish_day": 31,
        "publish_date": "昭和15年1月31日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 891,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第212號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 8,
        "publish_day": 18,
        "publish_date": "大正5年8月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 892,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1696號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 3,
        "publish_day": 11,
        "publish_date": "昭和15年3月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 893,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1391號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 3,
        "publish_day": 16,
        "publish_date": "昭和13年3月16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 894,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1844號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 2,
        "publish_day": 26,
        "publish_date": "昭和16年2月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 895,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2093號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 10,
        "publish_day": 7,
        "publish_date": "昭和17年10月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 896,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2301號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1944,
        "publish_month": 2,
        "publish_day": 28,
        "publish_date": "昭和19年2月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 897,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2129號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 1,
        "publish_day": 11,
        "publish_date": "昭和18年1月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 898,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2085號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 9,
        "publish_day": 18,
        "publish_date": "昭和17年9月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 899,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1852號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 3,
        "publish_day": 17,
        "publish_date": "昭和16年3月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 900,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第374號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 8,
        "publish_day": 15,
        "publish_date": "昭和5年8月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 901,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第282號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 12,
        "publish_day": 21,
        "publish_date": "大正6年12月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 902,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1680號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 2,
        "publish_day": 2,
        "publish_date": "昭和15年2月2日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 903,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第204號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 6,
        "publish_day": 23,
        "publish_date": "大正5年6月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 904,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第354號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 6,
        "publish_day": 6,
        "publish_date": "昭和5年6月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 905,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2148號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 2,
        "publish_day": 24,
        "publish_date": "昭和18年2月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 906,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第485號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1931,
        "publish_month": 9,
        "publish_day": 15,
        "publish_date": "昭和6年9月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 907,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第224號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 11,
        "publish_day": 10,
        "publish_date": "大正5年11月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 908,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1825號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 1,
        "publish_day": 13,
        "publish_date": "昭和16年1月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 909,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第493號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1931,
        "publish_month": 10,
        "publish_day": 13,
        "publish_date": "昭和6年10月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 910,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2027號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 5,
        "publish_day": 6,
        "publish_date": "昭和17年5月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 911,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第277號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 11,
        "publish_day": 16,
        "publish_date": "大正6年11月16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 912,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2070號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 8,
        "publish_day": 14,
        "publish_date": "昭和17年8月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 913,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第261號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 7,
        "publish_day": 27,
        "publish_date": "大正6年7月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 914,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第401號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 11,
        "publish_day": 18,
        "publish_date": "昭和5年11月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 915,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第199號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 5,
        "publish_day": 19,
        "publish_date": "大正5年5月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 916,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第378號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 8,
        "publish_day": 29,
        "publish_date": "昭和5年8月29日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 917,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2089號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 9,
        "publish_day": 28,
        "publish_date": "昭和17年9月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 918,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1366號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 1,
        "publish_day": 17,
        "publish_date": "昭和13年1月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 919,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1389號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 3,
        "publish_day": 11,
        "publish_date": "昭和13年3月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 920,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2031號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 5,
        "publish_day": 15,
        "publish_date": "昭和17年5月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 921,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第208號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 7,
        "publish_day": 21,
        "publish_date": "大正5年7月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 922,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第503號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1931,
        "publish_month": 11,
        "publish_day": 17,
        "publish_date": "昭和6年11月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 923,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第209號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 7,
        "publish_day": 28,
        "publish_date": "大正5年7月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 924,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第502號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1931,
        "publish_month": 11,
        "publish_day": 13,
        "publish_date": "昭和6年11月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 925,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2067號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 8,
        "publish_day": 7,
        "publish_date": "昭和17年8月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 926,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第379號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 9,
        "publish_day": 2,
        "publish_date": "昭和5年9月2日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 927,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2088號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 9,
        "publish_day": 25,
        "publish_date": "昭和17年9月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 928,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第260號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 7,
        "publish_day": 20,
        "publish_date": "大正6年7月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 929,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第400號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 11,
        "publish_day": 14,
        "publish_date": "昭和5年11月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 930,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第198號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 5,
        "publish_day": 12,
        "publish_date": "大正5年5月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 931,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2132號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 1,
        "publish_day": 18,
        "publish_date": "昭和18年1月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 932,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第380號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 9,
        "publish_day": 5,
        "publish_date": "昭和5年9月5日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 933,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2071號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 8,
        "publish_day": 17,
        "publish_date": "昭和17年8月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 934,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第276號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 11,
        "publish_day": 9,
        "publish_date": "大正6年11月9日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 935,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2026號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 5,
        "publish_day": 4,
        "publish_date": "昭和17年5月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 936,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第514號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1931,
        "publish_month": 12,
        "publish_day": 26,
        "publish_date": "昭和6年12月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 937,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1408號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 4,
        "publish_day": 25,
        "publish_date": "昭和13年4月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 938,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1371號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 1,
        "publish_day": 28,
        "publish_date": "昭和13年1月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 939,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1832號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 1,
        "publish_day": 29,
        "publish_date": "昭和16年1月29日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 940,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第484號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1931,
        "publish_month": 9,
        "publish_day": 11,
        "publish_date": "昭和6年9月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 941,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第225號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 11,
        "publish_day": 17,
        "publish_date": "大正5年11月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 942,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1824號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 1,
        "publish_day": 10,
        "publish_date": "昭和16年1月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 943,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2149號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 2,
        "publish_day": 26,
        "publish_date": "昭和18年2月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 944,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第355號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 6,
        "publish_day": 10,
        "publish_date": "昭和5年6月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 945,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1384號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 2,
        "publish_day": 28,
        "publish_date": "昭和13年2月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 946,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第205號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 6,
        "publish_day": 30,
        "publish_date": "大正5年6月30日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 947,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2084號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 9,
        "publish_day": 16,
        "publish_date": "昭和17年9月16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 948,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第363號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 7,
        "publish_day": 8,
        "publish_date": "昭和5年7月8日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 949,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1845號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 2,
        "publish_day": 28,
        "publish_date": "昭和16年2月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 950,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1678號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 1,
        "publish_day": 29,
        "publish_date": "昭和15年1月29日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 951,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1697號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 3,
        "publish_day": 13,
        "publish_date": "昭和15年3月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 952,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第213號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 8,
        "publish_day": 25,
        "publish_date": "大正5年8月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 953,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1404號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 4,
        "publish_day": 15,
        "publish_date": "昭和13年4月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 954,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2286號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1944,
        "publish_month": 1,
        "publish_day": 21,
        "publish_date": "昭和19年1月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 955,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第256號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 6,
        "publish_day": 22,
        "publish_date": "大正6年6月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 956,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2051號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 7,
        "publish_day": 1,
        "publish_date": "昭和17年7月1日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 957,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2153號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 3,
        "publish_day": 8,
        "publish_date": "昭和18年3月8日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 958,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第471號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1931,
        "publish_month": 7,
        "publish_day": 28,
        "publish_date": "昭和6年7月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 959,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2145號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 2,
        "publish_day": 17,
        "publish_date": "昭和18年2月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 960,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1828號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 1,
        "publish_day": 20,
        "publish_date": "昭和16年1月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 961,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1707號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 4,
        "publish_day": 5,
        "publish_date": "昭和15年4月5日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 962,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第229號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 12,
        "publish_day": 15,
        "publish_date": "大正5年12月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 963,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第488號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1931,
        "publish_month": 9,
        "publish_day": 25,
        "publish_date": "昭和6年9月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 964,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第467號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1931,
        "publish_month": 7,
        "publish_day": 14,
        "publish_date": "昭和6年7月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 965,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2102號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 10,
        "publish_day": 30,
        "publish_date": "昭和17年10月30日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 966,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第359號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 6,
        "publish_day": 24,
        "publish_date": "昭和5年6月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 967,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2047號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 6,
        "publish_day": 22,
        "publish_date": "昭和17年6月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 968,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第352號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 5,
        "publish_day": 30,
        "publish_date": "昭和5年5月30日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 969,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第222號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 10,
        "publish_day": 27,
        "publish_date": "大正5年10月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 970,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第483號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1931,
        "publish_month": 9,
        "publish_day": 8,
        "publish_date": "昭和6年9月8日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 971,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2158號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 3,
        "publish_day": 19,
        "publish_date": "昭和18年3月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 972,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1835號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 2,
        "publish_day": 5,
        "publish_date": "昭和16年2月5日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 973,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第344號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 5,
        "publish_day": 2,
        "publish_date": "昭和5年5月2日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 974,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1376號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 2,
        "publish_day": 9,
        "publish_date": "昭和13年2月9日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 975,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1399號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 4,
        "publish_day": 4,
        "publish_date": "昭和13年4月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 976,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第513號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1931,
        "publish_month": 12,
        "publish_day": 22,
        "publish_date": "昭和6年12月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 977,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第271號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 10,
        "publish_day": 5,
        "publish_date": "大正6年10月5日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 978,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2076號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 8,
        "publish_day": 28,
        "publish_date": "昭和17年8月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 979,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2099號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 10,
        "publish_day": 23,
        "publish_date": "昭和17年10月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 980,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第368號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 7,
        "publish_day": 25,
        "publish_date": "昭和5年7月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 981,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第407號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 12,
        "publish_day": 9,
        "publish_date": "昭和5年12月9日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 982,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第267號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 9,
        "publish_day": 7,
        "publish_date": "大正6年9月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 983,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2135號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 1,
        "publish_day": 25,
        "publish_date": "昭和18年1月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 984,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2060號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 7,
        "publish_day": 22,
        "publish_date": "昭和17年7月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 985,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第391號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 10,
        "publish_day": 14,
        "publish_date": "昭和5年10月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 986,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2125號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 12,
        "publish_day": 23,
        "publish_date": "昭和17年12月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 987,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1858號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 3,
        "publish_day": 31,
        "publish_date": "昭和16年3月31日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 988,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2037號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 5,
        "publish_day": 29,
        "publish_date": "昭和17年5月29日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 989,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第505號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1931,
        "publish_month": 11,
        "publish_day": 24,
        "publish_date": "昭和6年11月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 990,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2105號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 11,
        "publish_day": 6,
        "publish_date": "昭和17年11月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 991,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2040號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 6,
        "publish_day": 5,
        "publish_date": "昭和17年6月5日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 992,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2142號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 2,
        "publish_day": 10,
        "publish_date": "昭和18年2月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 993,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第499號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1931,
        "publish_month": 11,
        "publish_day": 4,
        "publish_date": "昭和6年11月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 994,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第476號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1931,
        "publish_month": 8,
        "publish_day": 14,
        "publish_date": "昭和6年8月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 995,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2113號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 11,
        "publish_day": 25,
        "publish_date": "昭和17年11月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 996,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第348號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 5,
        "publish_day": 16,
        "publish_date": "昭和5年5月16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 997,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2056號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 7,
        "publish_day": 13,
        "publish_date": "昭和17年7月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 998,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第251號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 5,
        "publish_day": 18,
        "publish_date": "大正6年5月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 999,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1403號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 4,
        "publish_day": 13,
        "publish_date": "昭和13年4月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1000,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第214號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 9,
        "publish_day": 1,
        "publish_date": "大正5年9月1日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1001,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第364號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 7,
        "publish_day": 11,
        "publish_date": "昭和5年7月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1002,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2095號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 10,
        "publish_day": 12,
        "publish_date": "昭和17年10月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1003,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1842號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 2,
        "publish_day": 21,
        "publish_date": "昭和16年2月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1004,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1854號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 3,
        "publish_day": 22,
        "publish_date": "昭和16年3月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1005,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2083號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 9,
        "publish_day": 14,
        "publish_date": "昭和17年9月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1006,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2311號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1944,
        "publish_month": 3,
        "publish_day": 22,
        "publish_date": "昭和19年3月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1007,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2139號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 2,
        "publish_day": 3,
        "publish_date": "昭和18年2月3日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1008,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1669號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 1,
        "publish_day": 8,
        "publish_date": "昭和15年1月8日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1009,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第509號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1931,
        "publish_month": 12,
        "publish_day": 8,
        "publish_date": "昭和6年12月8日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1010,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1382號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 2,
        "publish_day": 23,
        "publish_date": "昭和13年2月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1011,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第203號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 6,
        "publish_day": 16,
        "publish_date": "大正5年6月16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1012,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第508號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1931,
        "publish_month": 12,
        "publish_day": 4,
        "publish_date": "昭和6年12月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1013,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2310號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1944,
        "publish_month": 3,
        "publish_day": 20,
        "publish_date": "昭和19年3月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1014,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2138號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 2,
        "publish_day": 1,
        "publish_date": "昭和18年2月1日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1015,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1855號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 3,
        "publish_day": 24,
        "publish_date": "昭和16年3月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1016,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2082號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 9,
        "publish_day": 11,
        "publish_date": "昭和17年9月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1017,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2094號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 10,
        "publish_day": 9,
        "publish_date": "昭和17年10月9日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1018,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1843號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 2,
        "publish_day": 24,
        "publish_date": "昭和16年2月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1019,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1394號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 3,
        "publish_day": 23,
        "publish_date": "昭和13年3月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1020,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1402號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 4,
        "publish_day": 11,
        "publish_date": "昭和13年4月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1021,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第215號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 9,
        "publish_day": 8,
        "publish_date": "大正5年9月8日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1022,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第250號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 5,
        "publish_day": 11,
        "publish_date": "大正6年5月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1023,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第349號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 5,
        "publish_day": 20,
        "publish_date": "昭和5年5月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1024,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2057號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 7,
        "publish_day": 15,
        "publish_date": "昭和17年7月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1025,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1838號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 2,
        "publish_day": 12,
        "publish_date": "昭和16年2月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1026,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第498號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1931,
        "publish_month": 10,
        "publish_day": 30,
        "publish_date": "昭和6年10月30日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1027,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1701號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 3,
        "publish_day": 22,
        "publish_date": "昭和15年3月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1028,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2279號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1944,
        "publish_month": 1,
        "publish_day": 6,
        "publish_date": "昭和19年1月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1029,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2104號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 11,
        "publish_day": 4,
        "publish_date": "昭和17年11月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1030,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2041號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 6,
        "publish_day": 8,
        "publish_date": "昭和17年6月8日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1031,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2036號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 5,
        "publish_day": 27,
        "publish_date": "昭和17年5月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1032,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第504號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1931,
        "publish_month": 11,
        "publish_day": 20,
        "publish_date": "昭和6年11月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1033,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第390號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 10,
        "publish_day": 10,
        "publish_date": "昭和5年10月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1034,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第406號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 12,
        "publish_day": 5,
        "publish_date": "昭和5年12月5日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1035,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第266號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 8,
        "publish_day": 31,
        "publish_date": "大正6年8月31日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1036,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2134號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 1,
        "publish_day": 22,
        "publish_date": "昭和18年1月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1037,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第386號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 9,
        "publish_day": 26,
        "publish_date": "昭和5年9月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1038,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2098號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 10,
        "publish_day": 21,
        "publish_date": "昭和17年10月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1039,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第369號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 7,
        "publish_day": 29,
        "publish_date": "昭和5年7月29日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1040,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第270號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 9,
        "publish_day": 28,
        "publish_date": "大正6年9月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1041,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第410號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 12,
        "publish_day": 19,
        "publish_date": "昭和5年12月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1042,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1672號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 1,
        "publish_day": 15,
        "publish_date": "昭和15年1月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1043,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第219號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 10,
        "publish_day": 6,
        "publish_date": "大正5年10月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1044,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第512號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1931,
        "publish_month": 12,
        "publish_day": 18,
        "publish_date": "昭和6年12月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1045,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1377號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 2,
        "publish_day": 12,
        "publish_date": "昭和13年2月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1046,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1398號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 4,
        "publish_day": 1,
        "publish_date": "昭和13年4月1日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1047,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第345號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 5,
        "publish_day": 6,
        "publish_date": "昭和5年5月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1048,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第494號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1931,
        "publish_month": 10,
        "publish_day": 16,
        "publish_date": "昭和6年10月16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1049,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1834號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 2,
        "publish_day": 3,
        "publish_date": "昭和16年2月3日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1050,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2159號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 3,
        "publish_day": 22,
        "publish_date": "昭和18年3月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1051,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第223號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 11,
        "publish_day": 3,
        "publish_date": "大正5年11月3日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1052,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第482號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1931,
        "publish_month": 9,
        "publish_day": 4,
        "publish_date": "昭和6年9月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1053,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第353號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 6,
        "publish_day": 3,
        "publish_date": "昭和5年6月3日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1054,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第507號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1931,
        "publish_month": 12,
        "publish_day": 1,
        "publish_date": "昭和6年12月1日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1055,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2035號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 5,
        "publish_day": 25,
        "publish_date": "昭和17年5月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1056,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2160號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 3,
        "publish_day": 24,
        "publish_date": "昭和18年3月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1057,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2127號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 12,
        "publish_day": 28,
        "publish_date": "昭和17年12月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1058,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2062號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 7,
        "publish_day": 27,
        "publish_date": "昭和17年7月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1059,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第393號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 10,
        "publish_day": 21,
        "publish_date": "昭和5年10月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1060,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第265號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 8,
        "publish_day": 24,
        "publish_date": "大正6年8月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1061,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第405號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 12,
        "publish_day": 2,
        "publish_date": "昭和5年12月2日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1062,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第385號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 9,
        "publish_day": 23,
        "publish_date": "昭和5年9月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1063,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2074號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 8,
        "publish_day": 24,
        "publish_date": "昭和17年8月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1064,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第273號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 10,
        "publish_day": 19,
        "publish_date": "大正6年10月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1065,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第511號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1931,
        "publish_month": 12,
        "publish_day": 15,
        "publish_date": "昭和6年12月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1066,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1671號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 1,
        "publish_day": 12,
        "publish_date": "昭和15年1月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1067,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1374號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 2,
        "publish_day": 4,
        "publish_date": "昭和13年2月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1068,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2058號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 7,
        "publish_day": 17,
        "publish_date": "昭和17年7月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1069,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第346號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 5,
        "publish_day": 9,
        "publish_date": "昭和5年5月9日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1070,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第478號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1931,
        "publish_month": 8,
        "publish_day": 21,
        "publish_date": "昭和6年8月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1071,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1837號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 2,
        "publish_day": 10,
        "publish_date": "昭和16年2月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1072,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第497號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1931,
        "publish_month": 10,
        "publish_day": 27,
        "publish_date": "昭和6年10月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1073,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第220號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 10,
        "publish_day": 13,
        "publish_date": "大正5年10月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1074,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第350號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 5,
        "publish_day": 23,
        "publish_date": "昭和5年5月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1075,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第249號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 5,
        "publish_day": 4,
        "publish_date": "大正6年5月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1076,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1381號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 2,
        "publish_day": 21,
        "publish_date": "昭和13年2月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1077,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第200號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 5,
        "publish_day": 26,
        "publish_date": "大正5年5月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1078,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第409號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 12,
        "publish_day": 16,
        "publish_date": "昭和5年12月16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1079,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第269號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 9,
        "publish_day": 21,
        "publish_date": "大正6年9月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1080,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第370號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 8,
        "publish_day": 1,
        "publish_date": "昭和5年8月1日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1081,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第366號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 7,
        "publish_day": 18,
        "publish_date": "昭和5年7月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1082,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2097號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 10,
        "publish_day": 19,
        "publish_date": "昭和17年10月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1083,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1840號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 2,
        "publish_day": 17,
        "publish_date": "昭和16年2月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1084,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第389號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 10,
        "publish_day": 7,
        "publish_date": "昭和5年10月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1085,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第216號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 9,
        "publish_day": 15,
        "publish_date": "大正5年9月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1086,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1401號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 4,
        "publish_day": 8,
        "publish_date": "昭和13年4月8日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1087,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第253號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 6,
        "publish_day": 1,
        "publish_date": "大正6年6月1日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1088,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2043號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 6,
        "publish_day": 12,
        "publish_date": "昭和17年6月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1089,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1703號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 3,
        "publish_day": 27,
        "publish_date": "昭和15年3月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1090,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2141號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 2,
        "publish_day": 8,
        "publish_date": "昭和18年2月8日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1091,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第475號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1931,
        "publish_month": 8,
        "publish_day": 11,
        "publish_date": "昭和6年8月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1092,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2055號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 7,
        "publish_day": 10,
        "publish_date": "昭和17年7月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1093,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2110號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 11,
        "publish_day": 18,
        "publish_date": "昭和17年11月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1094,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第252號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 5,
        "publish_day": 25,
        "publish_date": "大正6年5月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1095,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第217號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 9,
        "publish_day": 22,
        "publish_date": "大正5年9月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1096,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1396號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 3,
        "publish_day": 28,
        "publish_date": "昭和13年3月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1097,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1379號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 2,
        "publish_day": 16,
        "publish_date": "昭和13年2月16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1098,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第367號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 7,
        "publish_day": 22,
        "publish_date": "昭和5年7月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1099,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2096號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 10,
        "publish_day": 14,
        "publish_date": "昭和17年10月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1100,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1841號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 2,
        "publish_day": 19,
        "publish_date": "昭和16年2月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1101,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2079號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 9,
        "publish_day": 4,
        "publish_date": "昭和17年9月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1102,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第388號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 10,
        "publish_day": 3,
        "publish_date": "昭和5年10月3日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1103,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1857號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 3,
        "publish_day": 28,
        "publish_date": "昭和16年3月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1104,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2080號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 9,
        "publish_day": 7,
        "publish_date": "昭和17年9月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1105,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第201號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 6,
        "publish_day": 2,
        "publish_date": "大正5年6月2日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1106,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1380號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 2,
        "publish_day": 18,
        "publish_date": "昭和13年2月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1107,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第351號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 5,
        "publish_day": 27,
        "publish_date": "昭和5年5月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1108,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第480號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1931,
        "publish_month": 8,
        "publish_day": 28,
        "publish_date": "昭和6年8月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1109,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第221號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 10,
        "publish_day": 20,
        "publish_date": "大正5年10月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1110,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第479號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1931,
        "publish_month": 8,
        "publish_day": 25,
        "publish_date": "昭和6年8月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1111,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1836號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 2,
        "publish_day": 7,
        "publish_date": "昭和16年2月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1112,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第496號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1931,
        "publish_month": 10,
        "publish_day": 23,
        "publish_date": "昭和6年10月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1113,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第347號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 5,
        "publish_day": 13,
        "publish_date": "昭和5年5月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1114,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1375號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 2,
        "publish_day": 7,
        "publish_date": "昭和13年2月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1115,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第510號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1931,
        "publish_month": 12,
        "publish_day": 11,
        "publish_date": "昭和6年12月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1116,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1670號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 1,
        "publish_day": 10,
        "publish_date": "昭和15年1月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1117,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2308號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1944,
        "publish_month": 3,
        "publish_day": 15,
        "publish_date": "昭和19年3月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1118,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第412號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 12,
        "publish_day": 26,
        "publish_date": "昭和5年12月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1119,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第272號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 10,
        "publish_day": 12,
        "publish_date": "大正6年10月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1120,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第384號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 9,
        "publish_day": 19,
        "publish_date": "昭和5年9月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1121,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2075號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 8,
        "publish_day": 26,
        "publish_date": "昭和17年8月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1122,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2136號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 1,
        "publish_day": 27,
        "publish_date": "昭和18年1月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1123,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第264號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 8,
        "publish_day": 17,
        "publish_date": "大正6年8月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1124,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第404號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 11,
        "publish_day": 28,
        "publish_date": "昭和5年11月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1125,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2126號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 12,
        "publish_day": 26,
        "publish_date": "昭和17年12月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1126,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2063號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 7,
        "publish_day": 29,
        "publish_date": "昭和17年7月29日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1127,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1363號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 1,
        "publish_day": 10,
        "publish_date": "昭和13年1月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1128,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1689號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 2,
        "publish_day": 23,
        "publish_date": "昭和15年2月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1129,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2034號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 5,
        "publish_day": 22,
        "publish_date": "昭和17年5月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1130,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1387號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 3,
        "publish_day": 7,
        "publish_date": "昭和13年3月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1131,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1368號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 1,
        "publish_day": 21,
        "publish_date": "昭和13年1月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1132,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第206號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 7,
        "publish_day": 7,
        "publish_date": "大正5年7月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1133,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第197號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 5,
        "publish_day": 5,
        "publish_date": "大正5年5月5日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1134,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第280號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 12,
        "publish_day": 7,
        "publish_date": "大正6年12月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1135,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2087號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 9,
        "publish_day": 23,
        "publish_date": "昭和17年9月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1136,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第399號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 11,
        "publish_day": 11,
        "publish_date": "昭和5年11月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1137,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2068號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 8,
        "publish_day": 10,
        "publish_date": "昭和17年8月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1138,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第279號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 11,
        "publish_day": 30,
        "publish_date": "大正6年11月30日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1139,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第360號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 6,
        "publish_day": 27,
        "publish_date": "昭和5年6月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1140,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1846號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 3,
        "publish_day": 3,
        "publish_date": "昭和16年3月3日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1141,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1407號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 4,
        "publish_day": 22,
        "publish_date": "昭和13年4月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1142,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1694號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 3,
        "publish_day": 6,
        "publish_date": "昭和15年3月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1143,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第210號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 8,
        "publish_day": 4,
        "publish_date": "大正5年8月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1144,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2029號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 5,
        "publish_day": 11,
        "publish_date": "昭和17年5月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1145,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第255號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 6,
        "publish_day": 15,
        "publish_date": "大正6年6月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1146,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2285號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1944,
        "publish_month": 1,
        "publish_day": 19,
        "publish_date": "昭和19年1月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1147,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2117號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 12,
        "publish_day": 4,
        "publish_date": "昭和17年12月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1148,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第472號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1931,
        "publish_month": 7,
        "publish_day": 31,
        "publish_date": "昭和6年7月31日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1149,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2146號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 2,
        "publish_day": 19,
        "publish_date": "昭和18年2月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1150,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第464號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1931,
        "publish_month": 7,
        "publish_day": 3,
        "publish_date": "昭和6年7月3日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1151,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2101號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 10,
        "publish_day": 28,
        "publish_date": "昭和17年10月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1152,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第501號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1931,
        "publish_month": 11,
        "publish_day": 10,
        "publish_date": "昭和6年11月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1153,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2033號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 5,
        "publish_day": 20,
        "publish_date": "昭和17年5月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1154,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1364號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 1,
        "publish_day": 12,
        "publish_date": "昭和13年1月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1155,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2121號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 12,
        "publish_day": 14,
        "publish_date": "昭和17年12月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1156,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2064號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 7,
        "publish_day": 31,
        "publish_date": "昭和17年7月31日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1157,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第395號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 10,
        "publish_day": 28,
        "publish_date": "昭和5年10月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1158,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2131號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 1,
        "publish_day": 15,
        "publish_date": "昭和18年1月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1159,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2319號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1944,
        "publish_month": 4,
        "publish_day": 14,
        "publish_date": "昭和19年4月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1160,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第403號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 11,
        "publish_day": 25,
        "publish_date": "昭和5年11月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1161,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第263號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 8,
        "publish_day": 10,
        "publish_date": "大正6年8月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1162,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第383號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 9,
        "publish_day": 16,
        "publish_date": "昭和5年9月16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1163,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2072號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 8,
        "publish_day": 19,
        "publish_date": "昭和17年8月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1164,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第275號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 11,
        "publish_day": 2,
        "publish_date": "大正6年11月2日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1165,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1698號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 3,
        "publish_day": 15,
        "publish_date": "昭和15年3月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1166,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2025號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 5,
        "publish_day": 1,
        "publish_date": "昭和17年5月1日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1167,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1372號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 1,
        "publish_day": 31,
        "publish_date": "昭和13年1月31日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1168,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第259號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 7,
        "publish_day": 13,
        "publish_date": "大正6年7月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1169,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2289號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1944,
        "publish_month": 1,
        "publish_day": 28,
        "publish_date": "昭和19年1月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1170,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第491號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1931,
        "publish_month": 10,
        "publish_day": 6,
        "publish_date": "昭和6年10月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1171,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1831號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 1,
        "publish_day": 27,
        "publish_date": "昭和16年1月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1172,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第230號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 12,
        "publish_day": 20,
        "publish_date": "大正5年12月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1173,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第468號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1931,
        "publish_month": 7,
        "publish_day": 17,
        "publish_date": "昭和6年7月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1174,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第226號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 11,
        "publish_day": 24,
        "publish_date": "大正5年11月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1175,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第487號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1931,
        "publish_month": 9,
        "publish_day": 22,
        "publish_date": "昭和6年9月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1176,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第356號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 6,
        "publish_day": 13,
        "publish_date": "昭和5年6月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1177,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第372號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 4,
        "publish_day": 30,
        "publish_date": "昭和16年4月30日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1178,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第357號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 6,
        "publish_day": 17,
        "publish_date": "昭和5年6月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1179,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第469號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1931,
        "publish_month": 7,
        "publish_day": 21,
        "publish_date": "昭和6年7月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1180,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第227號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 12,
        "publish_day": 1,
        "publish_date": "大正5年12月1日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1181,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1826號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 1,
        "publish_day": 15,
        "publish_date": "昭和16年1月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1182,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1709號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 4,
        "publish_day": 10,
        "publish_date": "昭和15年4月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1183,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第486號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1931,
        "publish_month": 9,
        "publish_day": 18,
        "publish_date": "昭和6年9月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1184,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1830號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 1,
        "publish_day": 24,
        "publish_date": "昭和16年1月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1185,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第231號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 12,
        "publish_day": 29,
        "publish_date": "大正5年12月29日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1186,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第258號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 7,
        "publish_day": 6,
        "publish_date": "大正6年7月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1187,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2322號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1944,
        "publish_month": 5,
        "publish_day": 5,
        "publish_date": "昭和19年5月5日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1188,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1373號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 2,
        "publish_day": 2,
        "publish_date": "昭和13年2月2日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1189,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1699號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 3,
        "publish_day": 18,
        "publish_date": "昭和15年3月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1190,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第274號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 10,
        "publish_day": 26,
        "publish_date": "大正6年10月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1191,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第382號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 9,
        "publish_day": 12,
        "publish_date": "昭和5年9月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1192,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2130號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 1,
        "publish_day": 13,
        "publish_date": "昭和18年1月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1193,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2318號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1944,
        "publish_month": 4,
        "publish_day": 7,
        "publish_date": "昭和19年4月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1194,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第402號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 11,
        "publish_day": 21,
        "publish_date": "昭和5年11月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1195,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第262號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 8,
        "publish_day": 3,
        "publish_date": "大正6年8月3日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1196,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2120號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 12,
        "publish_day": 11,
        "publish_date": "昭和17年12月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1197,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2065號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 8,
        "publish_day": 3,
        "publish_date": "昭和17年8月3日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1198,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第394號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 10,
        "publish_day": 24,
        "publish_date": "昭和5年10月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1199,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1365號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 1,
        "publish_day": 14,
        "publish_date": "昭和13年1月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1200,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第500號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1931,
        "publish_month": 11,
        "publish_day": 6,
        "publish_date": "昭和6年11月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1201,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2032號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 5,
        "publish_day": 18,
        "publish_date": "昭和17年5月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1202,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2100號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 10,
        "publish_day": 26,
        "publish_date": "昭和17年10月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1203,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2292號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1944,
        "publish_month": 2,
        "publish_day": 7,
        "publish_date": "昭和19年2月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1204,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第465號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1931,
        "publish_month": 7,
        "publish_day": 7,
        "publish_date": "昭和6年7月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1205,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1705號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 4,
        "publish_day": 1,
        "publish_date": "昭和15年4月1日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1206,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2151號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 3,
        "publish_day": 3,
        "publish_date": "昭和18年3月3日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1207,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2116號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 12,
        "publish_day": 2,
        "publish_date": "昭和17年12月2日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1208,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第254號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 6,
        "publish_day": 8,
        "publish_date": "大正6年6月8日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1209,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2284號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1944,
        "publish_month": 1,
        "publish_day": 17,
        "publish_date": "昭和19年1月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1210,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1406號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 4,
        "publish_day": 20,
        "publish_date": "昭和13年4月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1211,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第211號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 8,
        "publish_day": 11,
        "publish_date": "大正5年8月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1212,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1695號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 3,
        "publish_day": 8,
        "publish_date": "昭和15年3月8日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1213,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2028號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 5,
        "publish_day": 8,
        "publish_date": "昭和17年5月8日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1214,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1390號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 3,
        "publish_day": 14,
        "publish_date": "昭和13年3月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1215,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第361號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1930,
        "publish_month": 7,
        "publish_day": 1,
        "publish_date": "昭和5年7月1日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1216,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1847號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 3,
        "publish_day": 5,
        "publish_date": "昭和16年3月5日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1217,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2302號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1944,
        "publish_month": 3,
        "publish_day": 1,
        "publish_date": "昭和19年3月1日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1218,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第278號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 11,
        "publish_day": 23,
        "publish_date": "大正6年11月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1219,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2086號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 9,
        "publish_day": 21,
        "publish_date": "昭和17年9月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1220,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1851號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 3,
        "publish_day": 14,
        "publish_date": "昭和16年3月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1221,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2069號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 8,
        "publish_day": 12,
        "publish_date": "昭和17年8月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1222,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第281號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1917,
        "publish_month": 12,
        "publish_day": 14,
        "publish_date": "大正6年12月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1223,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第207號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1916,
        "publish_month": 7,
        "publish_day": 14,
        "publish_date": "大正5年7月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1224,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1410號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 4,
        "publish_day": 30,
        "publish_date": "昭和13年4月30日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1225,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1369號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 1,
        "publish_day": 24,
        "publish_date": "昭和13年1月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1226,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1468號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 9,
        "publish_day": 12,
        "publish_date": "昭和13年9月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1227,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1487號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 10,
        "publish_day": 26,
        "publish_date": "昭和13年10月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1228,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1491號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 11,
        "publish_day": 4,
        "publish_date": "昭和13年11月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1229,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1501號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 11,
        "publish_day": 28,
        "publish_date": "昭和13年11月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1230,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1464號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 9,
        "publish_day": 2,
        "publish_date": "昭和13年9月2日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1231,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1472號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 9,
        "publish_day": 21,
        "publish_date": "昭和13年9月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1232,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1465號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 9,
        "publish_day": 5,
        "publish_date": "昭和13年9月5日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1233,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1500號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 11,
        "publish_day": 25,
        "publish_date": "昭和13年11月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1234,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1490號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 11,
        "publish_day": 2,
        "publish_date": "昭和13年11月2日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1235,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1469號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 9,
        "publish_day": 14,
        "publish_date": "昭和13年9月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1236,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1486號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 10,
        "publish_day": 24,
        "publish_date": "昭和13年10月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1237,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1474號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 9,
        "publish_day": 26,
        "publish_date": "昭和13年9月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1238,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1481號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 10,
        "publish_day": 12,
        "publish_date": "昭和13年10月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1239,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1497號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 11,
        "publish_day": 18,
        "publish_date": "昭和13年11月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1240,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1511號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 12,
        "publish_day": 21,
        "publish_date": "昭和13年12月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1241,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1507號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 12,
        "publish_day": 12,
        "publish_date": "昭和13年12月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1242,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1506號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 12,
        "publish_day": 9,
        "publish_date": "昭和13年12月9日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1243,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1510號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 12,
        "publish_day": 19,
        "publish_date": "昭和13年12月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1244,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1479號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 10,
        "publish_day": 7,
        "publish_date": "昭和13年10月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1245,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1496號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 11,
        "publish_day": 16,
        "publish_date": "昭和13年11月16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1246,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1480號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 10,
        "publish_day": 10,
        "publish_date": "昭和13年10月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1247,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1499號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 11,
        "publish_day": 24,
        "publish_date": "昭和13年11月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1248,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1476號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 9,
        "publish_day": 30,
        "publish_date": "昭和13年9月30日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1249,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2333號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1944,
        "publish_month": 7,
        "publish_day": 21,
        "publish_date": "昭和19年7月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1250,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1513號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 12,
        "publish_day": 26,
        "publish_date": "昭和13年12月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1251,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1495號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 11,
        "publish_day": 14,
        "publish_date": "昭和13年11月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1252,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1483號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 10,
        "publish_day": 18,
        "publish_date": "昭和13年10月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1253,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1494號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 11,
        "publish_day": 11,
        "publish_date": "昭和13年11月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1254,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1512號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 12,
        "publish_day": 23,
        "publish_date": "昭和13年12月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1255,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1504號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 12,
        "publish_day": 5,
        "publish_date": "昭和13年12月5日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1256,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1498號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 11,
        "publish_day": 21,
        "publish_date": "昭和13年11月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1257,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1508號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 12,
        "publish_day": 14,
        "publish_date": "昭和13年12月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1258,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1503號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 12,
        "publish_day": 2,
        "publish_date": "昭和13年12月2日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1259,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1493號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 11,
        "publish_day": 9,
        "publish_date": "昭和13年11月9日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1260,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1485號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 10,
        "publish_day": 21,
        "publish_date": "昭和13年10月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1261,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1489號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 10,
        "publish_day": 31,
        "publish_date": "昭和13年10月31日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1262,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1466號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 9,
        "publish_day": 7,
        "publish_date": "昭和13年9月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1263,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2334號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1944,
        "publish_month": 7,
        "publish_day": 28,
        "publish_date": "昭和19年7月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1264,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1467號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 9,
        "publish_day": 9,
        "publish_date": "昭和13年9月9日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1265,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1471號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 9,
        "publish_day": 19,
        "publish_date": "昭和13年9月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1266,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1484號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 10,
        "publish_day": 20,
        "publish_date": "昭和13年10月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1267,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1492號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 11,
        "publish_day": 7,
        "publish_date": "昭和13年11月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1268,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1502號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1938,
        "publish_month": 11,
        "publish_day": 30,
        "publish_date": "昭和13年11月30日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1269,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2213號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 7,
        "publish_day": 26,
        "publish_date": "昭和18年7月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1270,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2227號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 8,
        "publish_day": 27,
        "publish_date": "昭和18年8月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1271,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2221號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 8,
        "publish_day": 13,
        "publish_date": "昭和18年8月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1272,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2020號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 4,
        "publish_day": 20,
        "publish_date": "昭和17年4月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1273,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2023號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 4,
        "publish_day": 27,
        "publish_date": "昭和17年4月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1274,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2019號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 4,
        "publish_day": 17,
        "publish_date": "昭和17年4月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1275,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2224號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 8,
        "publish_day": 20,
        "publish_date": "昭和18年8月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1276,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2014號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 4,
        "publish_day": 6,
        "publish_date": "昭和17年4月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1277,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2205號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 7,
        "publish_day": 7,
        "publish_date": "昭和18年7月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1278,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2233號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 9,
        "publish_day": 10,
        "publish_date": "昭和18年9月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1279,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2214號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 7,
        "publish_day": 28,
        "publish_date": "昭和18年7月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1280,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2202號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 6,
        "publish_day": 30,
        "publish_date": "昭和18年6月30日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1281,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2013號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 4,
        "publish_day": 4,
        "publish_date": "昭和17年4月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1282,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2204號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 7,
        "publish_day": 5,
        "publish_date": "昭和18年7月5日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1283,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2239號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 9,
        "publish_day": 25,
        "publish_date": "昭和18年9月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1284,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2215號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 7,
        "publish_day": 30,
        "publish_date": "昭和18年7月30日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1285,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1659號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 12,
        "publish_day": 6,
        "publish_date": "昭和14年12月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1286,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1663號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 12,
        "publish_day": 15,
        "publish_date": "昭和14年12月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1287,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1726號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 5,
        "publish_day": 20,
        "publish_date": "昭和15年5月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1288,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1662號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 12,
        "publish_day": 13,
        "publish_date": "昭和14年12月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1289,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1727號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 5,
        "publish_day": 22,
        "publish_date": "昭和15年5月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1290,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1654號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 11,
        "publish_day": 22,
        "publish_date": "昭和14年11月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1291,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1649號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 11,
        "publish_day": 13,
        "publish_date": "昭和14年11月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1292,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1720號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 5,
        "publish_day": 6,
        "publish_date": "昭和15年5月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1293,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1665號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 12,
        "publish_day": 20,
        "publish_date": "昭和14年12月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1294,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1653號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 11,
        "publish_day": 22,
        "publish_date": "昭和14年11月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1295,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1668號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 12,
        "publish_day": 27,
        "publish_date": "昭和14年12月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1296,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1652號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 11,
        "publish_day": 20,
        "publish_date": "昭和14年11月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1297,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1721號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 5,
        "publish_day": 8,
        "publish_date": "昭和15年5月8日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1298,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1648號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 11,
        "publish_day": 10,
        "publish_date": "昭和14年11月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1299,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1722號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 5,
        "publish_day": 10,
        "publish_date": "昭和15年5月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1300,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1651號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 11,
        "publish_day": 17,
        "publish_date": "昭和14年11月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1301,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1650號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 11,
        "publish_day": 15,
        "publish_date": "昭和14年11月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1302,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1723號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 5,
        "publish_day": 13,
        "publish_date": "昭和15年5月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1303,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1666號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 12,
        "publish_day": 22,
        "publish_date": "昭和14年12月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1304,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1728號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 5,
        "publish_day": 24,
        "publish_date": "昭和15年5月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1305,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1657號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 12,
        "publish_day": 1,
        "publish_date": "昭和14年12月1日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1306,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1661號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 12,
        "publish_day": 11,
        "publish_date": "昭和14年12月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1307,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1724號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 5,
        "publish_day": 15,
        "publish_date": "昭和15年5月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1308,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1660號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 12,
        "publish_day": 8,
        "publish_date": "昭和14年12月8日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 1309,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1656號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1939,
        "publish_month": 11,
        "publish_day": 29,
        "publish_date": "昭和14年11月29日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6194,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2337號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1944,
        "publish_month": 8,
        "publish_day": 18,
        "publish_date": "昭和19年8月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6197,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2336號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1944,
        "publish_month": 8,
        "publish_day": 11,
        "publish_date": "昭和19年8月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6198,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2341號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1944,
        "publish_month": 9,
        "publish_day": 15,
        "publish_date": "昭和19年9月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6210,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2347號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1944,
        "publish_month": 10,
        "publish_day": 27,
        "publish_date": "昭和19年10月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6211,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2351號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1944,
        "publish_month": 11,
        "publish_day": 24,
        "publish_date": "昭和19年11月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6216,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2344號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1944,
        "publish_month": 10,
        "publish_day": 6,
        "publish_date": "昭和19年10月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6218,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2352號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1944,
        "publish_month": 12,
        "publish_day": 1,
        "publish_date": "昭和19年12月1日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6220,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2353號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1944,
        "publish_month": 12,
        "publish_day": 8,
        "publish_date": "昭和19年12月8日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6221,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2345號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1944,
        "publish_month": 10,
        "publish_day": 13,
        "publish_date": "昭和19年10月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6222,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2349號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1944,
        "publish_month": 11,
        "publish_day": 10,
        "publish_date": "昭和19年11月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6233,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2257號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 11,
        "publish_day": 5,
        "publish_date": "昭和18年11月5日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6249,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2247號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 10,
        "publish_day": 13,
        "publish_date": "昭和18年10月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6250,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2246號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 10,
        "publish_day": 11,
        "publish_date": "昭和18年10月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6255,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2270號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 12,
        "publish_day": 9,
        "publish_date": "昭和18年12月9日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6256,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2266號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 11,
        "publish_day": 23,
        "publish_date": "昭和18年11月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6266,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2252號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 10,
        "publish_day": 25,
        "publish_date": "昭和18年10月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6280,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2263號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 11,
        "publish_day": 22,
        "publish_date": "昭和18年11月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6282,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第2262號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 11,
        "publish_day": 17,
        "publish_date": "昭和18年11月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6290,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1751號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 7,
        "publish_day": 17,
        "publish_date": "昭和15年7月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6291,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1891號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 6,
        "publish_day": 16,
        "publish_date": "昭和16年6月16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6299,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1747號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 7,
        "publish_day": 8,
        "publish_date": "昭和15年7月8日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6301,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1887號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 6,
        "publish_day": 6,
        "publish_date": "昭和16年6月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6303,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1956號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 11,
        "publish_day": 17,
        "publish_date": "昭和16年11月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6307,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1803號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 11,
        "publish_day": 15,
        "publish_date": "昭和15年11月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6314,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1917號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 8,
        "publish_day": 15,
        "publish_date": "昭和16年8月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6315,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1792號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 10,
        "publish_day": 21,
        "publish_date": "昭和15年10月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6318,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1940號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 10,
        "publish_day": 8,
        "publish_date": "昭和16年10月8日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6320,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1872號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 5,
        "publish_day": 2,
        "publish_date": "昭和16年5月2日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6322,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1937號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 10,
        "publish_day": 2,
        "publish_date": "昭和16年10月2日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6333,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1921號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 8,
        "publish_day": 25,
        "publish_date": "昭和16年8月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6336,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1730號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 5,
        "publish_day": 29,
        "publish_date": "昭和15年5月29日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6337,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1788號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 10,
        "publish_day": 11,
        "publish_date": "昭和15年10月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6338,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1767號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 8,
        "publish_day": 23,
        "publish_date": "昭和15年8月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6340,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1771號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 9,
        "publish_day": 2,
        "publish_date": "昭和15年9月2日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6341,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1819號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 12,
        "publish_day": 23,
        "publish_date": "昭和15年12月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6356,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1789號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 10,
        "publish_day": 14,
        "publish_date": "昭和15年10月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6357,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1766號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 8,
        "publish_day": 21,
        "publish_date": "昭和15年8月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6358,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1731號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 5,
        "publish_day": 31,
        "publish_date": "昭和15年5月31日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6359,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1920號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 8,
        "publish_day": 22,
        "publish_date": "昭和16年8月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6365,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1873號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 5,
        "publish_day": 5,
        "publish_date": "昭和16年5月5日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6366,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1936號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 9,
        "publish_day": 29,
        "publish_date": "昭和16年9月29日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6367,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1814號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 12,
        "publish_day": 11,
        "publish_date": "昭和15年12月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6369,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1941號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 10,
        "publish_day": 10,
        "publish_date": "昭和16年10月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6373,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1793號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 10,
        "publish_day": 23,
        "publish_date": "昭和15年10月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6374,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1785號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 10,
        "publish_day": 4,
        "publish_date": "昭和15年10月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6376,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1900號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 7,
        "publish_day": 7,
        "publish_date": "昭和16年7月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6379,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1802號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 11,
        "publish_day": 13,
        "publish_date": "昭和15年11月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6382,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1957號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 11,
        "publish_day": 19,
        "publish_date": "昭和16年11月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6387,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1746號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 7,
        "publish_day": 5,
        "publish_date": "昭和15年7月5日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6388,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1886號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 6,
        "publish_day": 4,
        "publish_date": "昭和16年6月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6393,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1890號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 6,
        "publish_day": 13,
        "publish_date": "昭和16年6月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6396,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1931號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 9,
        "publish_day": 17,
        "publish_date": "昭和16年9月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6401,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1966號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 12,
        "publish_day": 10,
        "publish_date": "昭和16年12月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6402,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1970號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 12,
        "publish_day": 19,
        "publish_date": "昭和16年12月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6405,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1927號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 9,
        "publish_day": 8,
        "publish_date": "昭和16年9月8日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6407,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1809號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 11,
        "publish_day": 29,
        "publish_date": "昭和15年11月29日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6413,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1761號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 8,
        "publish_day": 9,
        "publish_date": "昭和15年8月9日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6416,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1798號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 11,
        "publish_day": 4,
        "publish_date": "昭和15年11月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6417,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1777號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 9,
        "publish_day": 16,
        "publish_date": "昭和15年9月16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6419,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1757號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 7,
        "publish_day": 31,
        "publish_date": "昭和15年7月31日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6420,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1878號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 5,
        "publish_day": 16,
        "publish_date": "昭和16年5月16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6421,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1897號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 6,
        "publish_day": 30,
        "publish_date": "昭和16年6月30日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6427,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1741號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 6,
        "publish_day": 24,
        "publish_date": "昭和15年6月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6430,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1881號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 5,
        "publish_day": 23,
        "publish_date": "昭和16年5月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6432,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1950號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 11,
        "publish_day": 4,
        "publish_date": "昭和16年11月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6434,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1805號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 11,
        "publish_day": 20,
        "publish_date": "昭和15年11月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6435,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1782號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 9,
        "publish_day": 27,
        "publish_date": "昭和15年9月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6436,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1907號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 7,
        "publish_day": 23,
        "publish_date": "昭和16年7月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6438,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1794號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 10,
        "publish_day": 25,
        "publish_date": "昭和15年10月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6443,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1946號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 10,
        "publish_day": 24,
        "publish_date": "昭和16年10月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6447,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1947號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 10,
        "publish_day": 27,
        "publish_date": "昭和16年10月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6453,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1795號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 10,
        "publish_day": 28,
        "publish_date": "昭和15年10月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6456,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1783號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 9,
        "publish_day": 30,
        "publish_date": "昭和15年9月30日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6457,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1906號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 7,
        "publish_day": 21,
        "publish_date": "昭和16年7月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6460,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1804號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 11,
        "publish_day": 18,
        "publish_date": "昭和15年11月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6461,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1951號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 11,
        "publish_day": 5,
        "publish_date": "昭和16年11月5日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6464,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1880號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 5,
        "publish_day": 21,
        "publish_date": "昭和16年5月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6467,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1879號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 5,
        "publish_day": 19,
        "publish_date": "昭和16年5月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6468,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1756號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 7,
        "publish_day": 29,
        "publish_date": "昭和15年7月29日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6469,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1896號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 6,
        "publish_day": 27,
        "publish_date": "昭和16年6月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6471,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1799號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 11,
        "publish_day": 6,
        "publish_date": "昭和15年11月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6472,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1776號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 9,
        "publish_day": 13,
        "publish_date": "昭和15年9月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6475,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1760號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 8,
        "publish_day": 7,
        "publish_date": "昭和15年8月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6477,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1737號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 6,
        "publish_day": 14,
        "publish_date": "昭和15年6月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6481,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1808號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 11,
        "publish_day": 27,
        "publish_date": "昭和15年11月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6482,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1926號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 9,
        "publish_day": 5,
        "publish_date": "昭和16年9月5日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6485,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1971號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 12,
        "publish_day": 22,
        "publish_date": "昭和16年12月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6489,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1875號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 5,
        "publish_day": 9,
        "publish_date": "昭和16年5月9日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6490,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1930號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 9,
        "publish_day": 15,
        "publish_date": "昭和16年9月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6494,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1948號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 10,
        "publish_day": 29,
        "publish_date": "昭和16年10月29日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6495,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1775號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 9,
        "publish_day": 11,
        "publish_date": "昭和15年9月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6497,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1763號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 8,
        "publish_day": 14,
        "publish_date": "昭和15年8月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6501,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1909號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 7,
        "publish_day": 28,
        "publish_date": "昭和16年7月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6503,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1925號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 9,
        "publish_day": 3,
        "publish_date": "昭和16年9月3日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6505,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1972號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 12,
        "publish_day": 24,
        "publish_date": "昭和16年12月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6508,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1964號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 12,
        "publish_day": 5,
        "publish_date": "昭和16年12月5日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6513,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1899號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 7,
        "publish_day": 4,
        "publish_date": "昭和16年7月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6514,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1759號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 8,
        "publish_day": 5,
        "publish_date": "昭和15年8月5日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6517,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1811號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 12,
        "publish_day": 4,
        "publish_date": "昭和15年12月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6522,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1779號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 9,
        "publish_day": 20,
        "publish_date": "昭和15年9月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6523,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1913號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 8,
        "publish_day": 6,
        "publish_date": "昭和16年8月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6525,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1796號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 10,
        "publish_day": 30,
        "publish_date": "昭和15年10月30日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6527,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1780號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 9,
        "publish_day": 24,
        "publish_date": "昭和15年9月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6528,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1905號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 7,
        "publish_day": 18,
        "publish_date": "昭和16年7月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6529,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1807號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 11,
        "publish_day": 25,
        "publish_date": "昭和15年11月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6532,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1738號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 6,
        "publish_day": 17,
        "publish_date": "昭和15年6月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6533,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1952號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 11,
        "publish_day": 7,
        "publish_date": "昭和16年11月7日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6535,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1929號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 9,
        "publish_day": 12,
        "publish_date": "昭和16年9月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6536,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1883號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 5,
        "publish_day": 28,
        "publish_date": "昭和16年5月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6537,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1743號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 6,
        "publish_day": 28,
        "publish_date": "昭和15年6月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6541,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1895號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 6,
        "publish_day": 25,
        "publish_date": "昭和16年6月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6543,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1755號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 7,
        "publish_day": 26,
        "publish_date": "昭和15年7月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6544,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1894號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 6,
        "publish_day": 23,
        "publish_date": "昭和16年6月23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6545,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1754號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 7,
        "publish_day": 24,
        "publish_date": "昭和15年7月24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6546,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1969號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 12,
        "publish_day": 17,
        "publish_date": "昭和16年12月17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6552,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1928號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 9,
        "publish_day": 10,
        "publish_date": "昭和16年9月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6553,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1882號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 5,
        "publish_day": 26,
        "publish_date": "昭和16年5月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6554,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1742號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 6,
        "publish_day": 26,
        "publish_date": "昭和15年6月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6555,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1739號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 6,
        "publish_day": 19,
        "publish_date": "昭和15年6月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6556,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1953號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 11,
        "publish_day": 10,
        "publish_date": "昭和16年11月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6558,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1806號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 11,
        "publish_day": 22,
        "publish_date": "昭和15年11月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6560,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1781號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 9,
        "publish_day": 25,
        "publish_date": "昭和15年9月25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6561,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1904號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 7,
        "publish_day": 16,
        "publish_date": "昭和16年7月16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6562,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1778號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 9,
        "publish_day": 18,
        "publish_date": "昭和15年9月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6563,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1912號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 8,
        "publish_day": 4,
        "publish_date": "昭和16年8月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6564,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1797號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 11,
        "publish_day": 1,
        "publish_date": "昭和15年11月1日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6567,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1945號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 10,
        "publish_day": 22,
        "publish_date": "昭和16年10月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6568,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1810號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 12,
        "publish_day": 2,
        "publish_date": "昭和15年12月2日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6570,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1932號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 9,
        "publish_day": 19,
        "publish_date": "昭和16年9月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6572,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1877號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 5,
        "publish_day": 14,
        "publish_date": "昭和16年5月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6575,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1965號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 12,
        "publish_day": 8,
        "publish_date": "昭和16年12月8日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6579,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1924號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 9,
        "publish_day": 1,
        "publish_date": "昭和16年9月1日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6580,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1735號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 6,
        "publish_day": 10,
        "publish_date": "昭和15年6月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6581,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1762號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 8,
        "publish_day": 12,
        "publish_date": "昭和15年8月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6586,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1774號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 9,
        "publish_day": 9,
        "publish_date": "昭和15年9月9日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6588,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1949號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 10,
        "publish_day": 31,
        "publish_date": "昭和16年10月31日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6591,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1942號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 10,
        "publish_day": 13,
        "publish_date": "昭和16年10月13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6593,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1915號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 8,
        "publish_day": 11,
        "publish_date": "昭和16年8月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6594,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1790號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 10,
        "publish_day": 16,
        "publish_date": "昭和15年10月16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6596,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1769號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 8,
        "publish_day": 28,
        "publish_date": "昭和15年8月28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6599,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1903號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 7,
        "publish_day": 14,
        "publish_date": "昭和16年7月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6601,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1801號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 11,
        "publish_day": 11,
        "publish_date": "昭和15年11月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6603,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1885號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 6,
        "publish_day": 2,
        "publish_date": "昭和16年6月2日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6604,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1745號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 7,
        "publish_day": 3,
        "publish_date": "昭和15年7月3日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6610,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1893號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 6,
        "publish_day": 20,
        "publish_date": "昭和16年6月20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6611,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1939號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 10,
        "publish_day": 6,
        "publish_date": "昭和16年10月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6613,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1753號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 7,
        "publish_day": 22,
        "publish_date": "昭和15年7月22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6616,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1773號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 9,
        "publish_day": 6,
        "publish_date": "昭和15年9月6日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6621,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1765號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 8,
        "publish_day": 19,
        "publish_date": "昭和15年8月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6623,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1732號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 6,
        "publish_day": 3,
        "publish_date": "昭和15年6月3日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6624,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1958號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 11,
        "publish_day": 21,
        "publish_date": "昭和16年11月21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6625,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1889號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 6,
        "publish_day": 11,
        "publish_date": "昭和16年6月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6626,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1923號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 8,
        "publish_day": 29,
        "publish_date": "昭和16年8月29日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6627,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1749號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 7,
        "publish_day": 12,
        "publish_date": "昭和15年7月12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6630,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1974號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 12,
        "publish_day": 29,
        "publish_date": "昭和16年12月29日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6634,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1962號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 12,
        "publish_day": 1,
        "publish_date": "昭和16年12月1日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6636,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1935號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 9,
        "publish_day": 26,
        "publish_date": "昭和16年9月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6639,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1871號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 4,
        "publish_day": 30,
        "publish_date": "昭和16年4月30日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6641,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1820號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 12,
        "publish_day": 26,
        "publish_date": "昭和15年12月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6644,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1888號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 6,
        "publish_day": 9,
        "publish_date": "昭和16年6月9日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6645,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1922號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 8,
        "publish_day": 27,
        "publish_date": "昭和16年8月27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6646,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1748號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 7,
        "publish_day": 10,
        "publish_date": "昭和15年7月10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6653,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1772號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 9,
        "publish_day": 4,
        "publish_date": "昭和15年9月4日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6655,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1918號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 8,
        "publish_day": 18,
        "publish_date": "昭和16年8月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6659,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1892號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 6,
        "publish_day": 18,
        "publish_date": "昭和16年6月18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6660,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1938號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 10,
        "publish_day": 3,
        "publish_date": "昭和16年10月3日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6662,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1752號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 7,
        "publish_day": 19,
        "publish_date": "昭和15年7月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6669,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1884號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 5,
        "publish_day": 30,
        "publish_date": "昭和16年5月30日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6670,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1744號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 7,
        "publish_day": 1,
        "publish_date": "昭和15年7月1日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6673,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1955號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 11,
        "publish_day": 14,
        "publish_date": "昭和16年11月14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6674,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1800號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 11,
        "publish_day": 8,
        "publish_date": "昭和15年11月8日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6676,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1768號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 8,
        "publish_day": 26,
        "publish_date": "昭和15年8月26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6678,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1902號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 7,
        "publish_day": 11,
        "publish_date": "昭和16年7月11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6680,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1791號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1940,
        "publish_month": 10,
        "publish_day": 19,
        "publish_date": "昭和15年10月19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6682,
        "book_type": null,
        "book_category": "dobo",
        "book_title": "京畿道報",
        "book_title_ko": "경기도보",
        "numeration": "第1943號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1941,
        "publish_month": 10,
        "publish_day": 15,
        "publish_date": "昭和16年10月15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    }
]